const it = {
  'common.loading': 'Caricamento…',
  'common.save': 'Salva',
  'common.saving': 'Salvataggio…',
  'common.cancel': 'Annulla',
  'common.delete': 'Elimina',
  'common.search': 'Cerca',
  'common.clearSearch': 'Cancella ricerca',
  'common.sortBy': 'Ordina per',
  'common.name': 'Nome',
  'common.role': 'Ruolo',
  'common.groups': 'Gruppi',
  'common.tickets': 'Ticket',
  'common.lastSeen': 'Ultimo accesso',
  'common.actions': 'Azioni',
  'common.never': 'Mai',
  'common.justNow': 'Adesso',
  'common.minutesAgo': '{count} min fa',
  'common.hoursAgo': '{count} h fa',
  'common.daysAgo': '{count} g fa',
  'common.accessDenied': 'Accesso negato',
  'common.noPagePermission': 'Non hai l’autorizzazione per accedere a questa pagina.',
  'common.roleNoPermission': 'Il tuo ruolo non ha l’autorizzazione per accedere a questa pagina.',
  'common.requestFailed': 'Richiesta non riuscita. Riprova.',
  'common.unexpectedError': 'Si è verificato un errore imprevisto',
  'common.backToLogin': 'Torna all’accesso',
  'common.markAsRead': 'Segna come letto',
  'common.user': 'Utente',
  'shell.skipToMain': 'Vai al contenuto principale',
  'shell.homeLabel': 'Home di Suzuki Support Desk',
  'shell.supportDesk': 'Centro assistenza',
  'shell.searchPlaceholder': 'Cerca ticket, contatti, articoli…',
  'shell.newTicket': 'Nuovo ticket',
  'shell.userMenu': 'Menu utente',
  'shell.notifications': 'Notifiche',
  'shell.unread': '{count} non lette',
  'shell.notificationPreferences': 'Preferenze di notifica',
  'shell.settings': 'Impostazioni',
  'shell.signOut': 'Esci',
  'shell.expandNavigation': 'Espandi navigazione',
  'shell.collapseNavigation': 'Comprimi navigazione',
  'shell.adminNavigation': 'Navigazione amministrazione',
  'shell.caughtUp': 'Sei in pari con tutto',
  'shell.notificationDescription': 'Nuove assegnazioni, risposte e avvisi SLA appariranno qui.',
  'shell.viewAllNotifications': 'Vedi tutte le notifiche',

  'nav.dashboard': 'Dashboard',
  'nav.tickets': 'Ticket',
  'nav.contacts': 'Contatti',
  'nav.companies': 'Aziende',
  'nav.reports': 'Report',
  'nav.settings': 'Impostazioni',
  'nav.agents': 'Agenti',
  'nav.groups': 'Gruppi',
  'nav.roles': 'Ruoli',
  'nav.tags': 'Tag',
  'nav.ticketFields': 'Campi ticket',
  'nav.ticketForms': 'Moduli ticket',
  'nav.businessHours': 'Orari di lavoro',
  'nav.slaPolicies': 'Policy SLA',
  'nav.automations': 'Automazioni',
  'nav.email': 'Email',
  'nav.jira': 'Integrazione Jira',
  'nav.notificationTemplates': 'Modelli di notifica',
  'nav.apiKeys': 'Chiavi API',
  'nav.cannedResponses': 'Risposte predefinite',
  'nav.knowledgeBase': 'Knowledge Base',

  'auth.twoFactor': 'Autenticazione a due fattori',
  'auth.enterAuthenticatorCode': 'Inserisci il codice a 6 cifre della tua app di autenticazione',
  'auth.verificationCode': 'Codice di verifica',
  'auth.verifying': 'Verifica in corso…',
  'auth.verify': 'Verifica',
  'auth.setupAuthenticator': 'Configura l’autenticatore',
  'auth.scanAuthenticator': 'Scansiona questo codice con la tua app di autenticazione (Google Authenticator, Authy, ecc.)',
  'auth.authenticatorSetupQr': 'Codice QR per la configurazione dell’autenticatore',
  'auth.verificationCodeFromAuthenticator': 'Codice di verifica dall’autenticatore',
  'auth.verifyAndComplete': 'Verifica e completa la configurazione',
  'auth.loadingSetup': 'Caricamento della configurazione…',
  'auth.setNewPassword': 'Imposta una nuova password',
  'auth.temporaryPasswordExpired': 'La tua password temporanea è scaduta. Imposta una nuova password.',
  'auth.newPassword': 'Nuova password',
  'auth.confirmPassword': 'Conferma password',
  'auth.settingPassword': 'Impostazione della password…',
  'auth.setPassword': 'Imposta password',
  'auth.passwordRequirements': 'Almeno 8 caratteri, con maiuscola, minuscola, numero e simbolo',
  'auth.signInTitle': 'SDPL Support Desk',
  'auth.signInSubtitle': 'Accedi al tuo account',
  'auth.emailAddress': 'Indirizzo email',
  'auth.password': 'Password',
  'auth.signingIn': 'Accesso in corso…',
  'auth.signIn': 'Accedi',
  'auth.forgotPassword': 'Hai dimenticato la password?',
  'auth.tooManyAttempts': 'Troppi tentativi di accesso. Riprova più tardi.',
  'auth.invalidCredentials': 'Email o password non valide',
  'auth.passwordsDoNotMatch': 'Le password non coincidono',
  'auth.passwordMinimum': 'La password deve contenere almeno {count} caratteri',
  'auth.resetTitle': 'Reimposta la password',
  'auth.resetSubtitle': 'Inserisci la tua email e ti invieremo un link per reimpostarla',
  'auth.checkEmail': 'Controlla la tua email per il link di reimpostazione',
  'auth.checkCode': 'Controlla la tua email per il codice di verifica, poi continua qui sotto.',
  'auth.continueToReset': 'Continua per reimpostare la password',
  'auth.sendResetLink': 'Invia link di reimpostazione',
  'auth.sending': 'Invio in corso…',
  'auth.resetSuccess': 'La tua password è stata reimpostata correttamente.',
  'auth.goToLogin': 'Vai all’accesso',
  'auth.missingResetToken': 'Token di reimpostazione mancante. Usa il link ricevuto via email.',
  'auth.enterCodeFromEmail': 'Inserisci il codice di verifica inviato alla tua email',
  'auth.codeFromEmail': 'Inserisci il codice ricevuto via email',
  'auth.emailRequired': 'L’email è obbligatoria',
  'auth.codeRequired': 'Il codice di verifica è obbligatorio',
  'auth.missingToken': 'Token di reimpostazione mancante',
  'auth.failedReset': 'Impossibile reimpostare la password.',
  'auth.resetting': 'Reimpostazione in corso…',
  'auth.resetPassword': 'Reimposta password',
  'auth.looksGood': 'Va bene',
  'auth.needCharacters': 'Servono almeno {count} caratteri',
  'auth.passwordFormat': 'Almeno {count} caratteri, con maiuscola, minuscola, numero e simbolo',

  'agents.title': 'Agenti',
  'agents.description': 'Le persone che gestiscono i ticket. Assegna un ruolo per definire cosa possono fare e dei gruppi per definire cosa possono vedere.',
  'agents.new': 'Nuovo agente',
  'agents.supportAgents': 'Agenti di supporto',
  'agents.collaborators': 'Collaboratori',
  'agents.deactivated': 'Disattivati',
  'agents.searchPlaceholder': 'Cerca per nome o email',
  'agents.searchAria': 'Cerca agenti',
  'agents.countOne': '{count} agente',
  'agents.countMany': '{count} agenti',
  'agents.ticketOne': '{count} ticket',
  'agents.ticketMany': '{count} ticket',
  'agents.noGroups': 'Nessun gruppo',
  'agents.lifecycle': 'Ciclo di vita dell’agente',
  'agents.noSearchResults': 'Nessun agente corrisponde a questa ricerca',
  'agents.noAgentsView': 'Nessun agente in questa vista',
  'agents.tryDifferent': 'Prova con un altro nome o indirizzo email.',
  'agents.useNewAgent': 'Usa Nuovo agente per aggiungere qualcuno, oppure cambia scheda per vedere altri agenti.',
  'agents.agent': 'Agente',
  'agents.noRole': 'Nessun ruolo',
  'agents.openTicketsTitle': 'Ticket aperti attualmente assegnati a questo agente',
  'agents.edit': 'Modifica',
  'agents.moreActions': 'Altre azioni per {name}',
  'agents.confirmDeleteTitle': 'Eliminare {name}?',
  'agents.confirmDeleteDescription': 'Questa azione non può essere annullata. Gli agenti collegati a dei ticket non possono essere eliminati: disattivali.',
  'agents.confirmDeleteLabel': 'Elimina agente',
  'agents.deactivate': 'Disattiva',
  'agents.reactivate': 'Riattiva',
  'agents.agentsVsCollaborators': 'Agenti e collaboratori',
  'agents.agentsVsCollaboratorsBody': 'Gli agenti di supporto gestiscono i ticket ogni giorno. I collaboratori hanno un ruolo di collaboratore e sono in genere esperti coinvolti su singoli ticket senza accesso completo da agente.',
  'agents.deactivateVsDelete': 'Disattivare o eliminare',
  'agents.deactivateVsDeleteBody': 'La disattivazione mantiene intatti storico e titolarità dei ticket, ma blocca l’accesso. L’eliminazione è permanente ed è possibile solo quando l’agente non ha ticket collegati.',
  'agents.newTitle': 'Nuovo agente',
  'agents.editTitle': 'Modifica agente',
  'agents.saved': 'Agente salvato.',
  'agents.firstName': 'Nome',
  'agents.lastName': 'Cognome',
  'agents.email': 'Email',
  'agents.temporaryPassword': 'Password temporanea',
  'agents.passwordHelp': 'Almeno 12 caratteri, con una maiuscola, una minuscola, un numero e un simbolo. All’agente verrà chiesto di cambiarla al primo accesso.',
  'agents.phone': 'Telefono',
  'agents.timezone': 'Fuso orario',
  'agents.selectTimezone': 'Seleziona il fuso orario',
  'agents.timezoneHelp': 'Tutte le date e gli orari visualizzati da questo agente sono mostrati in questo fuso orario.',
  'agents.language': 'Lingua',
  'agents.selectLanguage': 'Seleziona la lingua',
  'agents.languageHelp': 'Traduce l’interfaccia per gli agenti. Le risposte ai ticket e i contenuti dei clienti non vengono tradotti.',
  'agents.emailSignature': 'Firma email',
  'agents.signaturePlaceholder': 'Aggiunta alle risposte in uscita',
  'agents.roleRequired': 'Ruolo',
  'agents.selectRole': 'Seleziona il ruolo',
  'agents.roleHelp': 'Determina cosa può fare questo agente.',
  'agents.manageRoles': 'Gestisci ruoli',
  'agents.status': 'Stato',
  'agents.activeHelp': 'Attivo: deselezionando blocchi l’accesso senza eliminare l’agente',
  'agents.groupsTitle': 'Gruppi',
  'agents.assignGroups': 'Assegna gruppi',
  'agents.selectGroups': 'Seleziona i gruppi',
  'agents.assignGroupsHelp': 'L’appartenenza ai gruppi definisce quali ticket l’agente può vedere.',
  'agents.ticketVisibility': 'Visibilità dei ticket',
  'agents.ticketVisibilityHelp': 'Scegli un limite più ristretto per l’agente oppure eredita quello predefinito del ruolo. I permessi del ruolo continuano a definire cosa l’agente può fare.',
  'agents.scopeRoleDefault': 'Usa il valore predefinito del ruolo',
  'agents.scopeRoleDefaultHelp': 'Eredita la visibilità predefinita configurata per questo ruolo.',
  'agents.scopeAll': 'Tutti i ticket',
  'agents.scopeAllHelp': 'Vede tutti i ticket non eliminati di questo account.',
  'agents.scopeGroup': 'Ticket di un gruppo',
  'agents.scopeGroupHelp': 'Vede i ticket assegnati ai gruppi a cui appartiene l’agente.',
  'agents.scopeAssigned': 'Ticket assegnati',
  'agents.scopeAssignedHelp': 'Vede i ticket assegnati direttamente a questo agente.',
  'agents.scopeCollaboratorHelp': 'I collaboratori restano limitati ai ticket dei loro gruppi L1.',
  'agents.manageGroups': 'Gestisci gruppi',
  'agents.notInGroup': 'Non fa ancora parte di nessun gruppo',
  'agents.groupHelp': 'Aggiungi questo agente a un gruppo dalla schermata Gruppi per definire quali ticket può vedere.',
  'agents.about': 'Informazioni su questo agente',
  'agents.aboutBody': 'Nome, email, telefono, fuso orario, lingua e firma identificano l’agente e personalizzano il suo spazio di lavoro. Il ruolo definisce cosa può fare; l’appartenenza ai gruppi definisce quali ticket può vedere.',

  'dashboard.title': 'Dashboard',
  'dashboard.description': 'Carico di lavoro attuale e stato del servizio.',
  'dashboard.allGroups': 'Tutti i gruppi accessibili',
  'dashboard.unresolved': 'Non risolti',
  'dashboard.overdue': 'In ritardo',
  'dashboard.dueToday': 'In scadenza oggi',
  'dashboard.open': 'Aperti',
  'dashboard.onHold': 'In sospeso',
  'dashboard.unassigned': 'Non assegnati',
  'dashboard.trends': 'Andamento di oggi',
  'dashboard.trendsDescription': 'Creazione di ticket per ora UTC, a confronto con ieri.',
  'dashboard.today': 'Oggi',
  'dashboard.yesterday': 'Ieri',
  'dashboard.chartAria': 'Volume di ticket per ora UTC, oggi rispetto a ieri',
  'dashboard.dataUnavailable': 'I dati della dashboard non sono disponibili.',
  'dashboard.loadError': 'Impossibile caricare i dati della dashboard. Riprova.',

  'notifications.title': 'Notifiche',
  'notifications.description': 'Tutto lo storico delle tue notifiche.',
  'notifications.markAllRead': 'Segna tutte come lette',
  'notifications.filter': 'Filtro',
  'notifications.allTypes': 'Tutti i tipi',
  'notifications.noType': 'Nessuna notifica di questo tipo',
  'notifications.none': 'Ancora nessuna notifica',
  'notifications.allTypesHint': 'Scegli “Tutti i tipi” qui sopra per vedere il resto dello storico.',
  'notifications.emptyDescription': 'Assegnazioni, risposte e avvisi SLA arrivano qui. Nelle preferenze di notifica puoi scegliere quali ricevere anche via email.',
  'notifications.assigned': 'Assegnato',
  'notifications.groupAssigned': 'Assegnazione al gruppo',
  'notifications.groupMemberAdded': 'Aggiunto al gruppo',
  'notifications.reply': 'Risposta',
  'notifications.note': 'Nota',
  'notifications.slaWarning': 'Avviso SLA',
  'notifications.slaBreach': 'Violazione SLA',
  'notifications.slaEscalation': 'Escalation SLA',
  'notifications.mention': 'Menzione',

  'preferences.title': 'Preferenze di notifica',
  'preferences.description': 'Le notifiche nell’app restano sempre attive. Scegli quali inviare anche via email.',
  'preferences.emailDigest': 'Riepilogo via email',
  'preferences.dailySummary': 'Ricevi una sola email di riepilogo al giorno invece di una email per ogni evento qui sotto.',
  'preferences.digestOff': 'Disattivato: una email per ogni evento',
  'preferences.digestDaily': 'Riepilogo giornaliero',
  'preferences.digestWarning': 'Hai attivato il riepilogo giornaliero, quindi queste impostazioni vengono ignorate finché non lo disattivi.',
  'preferences.emailNotifications': 'Notifiche via email',
  'preferences.createdEvent': 'Viene creato un ticket',
  'preferences.assignedEvent': 'Un ticket ti viene assegnato',
  'preferences.groupAssignedEvent': 'Un ticket viene assegnato a uno dei tuoi gruppi',
  'preferences.groupMemberAddedEvent': 'Vieni aggiunto a un gruppo di supporto',
  'preferences.replyEvent': 'Un ticket a cui partecipi riceve una risposta',
  'preferences.noteEvent': 'Viene aggiunta una nota privata',
  'preferences.slaWarningEvent': 'L’SLA si avvicina alla scadenza',
  'preferences.slaBreachEvent': 'L’SLA viene violato',
  'preferences.slaEscalationEvent': 'L’SLA viene escalato oltre la scadenza',
  'preferences.mentionEvent': 'Vieni menzionato in un ticket',
  'preferences.pendingInputEvent': 'Un ticket è in attesa di una tua risposta',
  'preferences.resolvedEvent': 'Un ticket viene risolto',

  'activities.button': 'Attività recenti',
  'activities.title': 'Attività recenti',
  'activities.loadError': 'Impossibile caricare le attività recenti.',
  'activities.systemActor': 'Sistema',
  'activities.noneTitle': 'Ancora nessuna attività recente',
  'activities.noneDescription': 'Gli aggiornamenti dei ticket tuoi e del tuo gruppo appariranno qui man mano che avvengono.',

  'tickets.title': 'Ticket',
  'tickets.description': 'Tutti i ticket a cui hai accesso, filtrati e ordinati come preferisci.',
  'tickets.dueDateTabs': 'Scadenza del ticket',
  'tickets.tabAll': 'Tutti i ticket',
  'tickets.tabDueToday': 'In scadenza oggi',
  'tickets.tabOverdue': 'In ritardo',
  'tickets.tabDueTomorrow': 'In scadenza domani',
  'tickets.searchPlaceholder': 'Cerca ticket…',
  'tickets.searchAria': 'Cerca ticket',
  'tickets.filters': 'Filtri',
  'tickets.filtersWithCount': 'Filtri ({count})',
  'tickets.sortAria': 'Ordina i ticket per',
  'tickets.sortTrigger': 'Ordina: {label}',
  'tickets.sortDateCreated': 'Data di creazione',
  'tickets.sortDateUpdated': 'Data di aggiornamento',
  'tickets.sortPriority': 'Priorità',
  'tickets.sortStatus': 'Stato',
  'tickets.sortDueDate': 'Scadenza',
  'tickets.sortAscending': 'Ordine crescente',
  'tickets.sortDescending': 'Ordine decrescente',
  'tickets.ascending': 'Crescente',
  'tickets.descending': 'Decrescente',
  'tickets.layoutAria': 'Layout delle righe',
  'tickets.layoutTrigger': 'Layout: {label}',
  'tickets.layoutCard': 'Scheda',
  'tickets.layoutInbox': 'Posta in arrivo',
  'tickets.layoutTable': 'Tabella',
  'tickets.export': 'Esporta',
  'tickets.exportSelected': 'Esporta selezionati',
  'tickets.selectedCount': '{count} selezionati',
  'tickets.assignAgent': 'Assegna agente',
  'tickets.closeAll': 'Chiudi tutti',
  'tickets.clearSelection': 'Deseleziona',
  'tickets.selectAgentPlaceholder': 'Seleziona un agente...',
  'tickets.assignTo': 'Assegna a',
  'tickets.assign': 'Assegna',
  'tickets.loadFailed': 'Impossibile caricare i ticket. Riprova.',
  'tickets.bulkCloseFailed': 'Impossibile chiudere i ticket selezionati. Riprova.',
  'tickets.bulkAssignFailed': 'Impossibile assegnare i ticket selezionati. Riprova.',
  'tickets.noFilterMatchTitle': 'Nessun ticket corrisponde a questi filtri',
  'tickets.noFilterMatchDescription': 'Prova a rimuovere un filtro, ad ampliare l’intervallo di date o a cercare un altro termine.',
  'tickets.clearFilters': 'Cancella filtri',
  'tickets.queueClearTitle': 'Questa coda è vuota',
  'tickets.queueClearDescription': 'I nuovi ticket compaiono qui quando i clienti scrivono via email, usano il portale o un agente ne crea uno.',
  'tickets.newTicket': 'Nuovo ticket',
  'tickets.selectAllAria': 'Seleziona tutti i ticket',
  'tickets.selectTicketAria': 'Seleziona il ticket #{number}',
  'tickets.columnContact': 'Contatto',
  'tickets.columnSubject': 'Oggetto',
  'tickets.columnState': 'Stato',
  'tickets.columnGroup': 'Gruppo',
  'tickets.columnAgent': 'Agente',
  'tickets.columnPriority': 'Priorità',
  'tickets.noGroup': 'Nessun gruppo',
  'tickets.unassigned': 'Non assegnato',
  'tickets.createdRelative': 'Creato {when}',
  'tickets.unassignedOnly': 'Solo non assegnati',
  'tickets.unknownRequester': 'Richiedente sconosciuto',
  'tickets.overdueBy': 'In ritardo di {duration}',
  'tickets.dueIn': 'Scade tra {duration}',
  'tickets.filtersDrawerTitle': 'Filtri',
  'tickets.filtersSearchPlaceholder': 'Cerca campi',
  'tickets.filtersSearchAria': 'Cerca campi filtro',
  'tickets.filtersClearAll': 'Cancella tutto',
  'tickets.filtersApply': 'Applica',
  'tickets.filterAgents': 'Agenti',
  'tickets.filterAnyAgent': 'Qualsiasi agente',
  'tickets.filterGroups': 'Gruppi',
  'tickets.filterAnyGroup': 'Qualsiasi gruppo',
  'tickets.filterStatus': 'Stato',
  'tickets.filterAnyStatus': 'Qualsiasi stato',
  'tickets.filterPriority': 'Priorità',
  'tickets.filterAnyPriority': 'Qualsiasi priorità',
  'tickets.filterSource': 'Origine',
  'tickets.filterAnySource': 'Qualsiasi origine',
  'tickets.filterTicketType': 'Tipo di ticket',
  'tickets.filterAnyType': 'Qualsiasi tipo',
  'tickets.filterTags': 'Tag',
  'tickets.filterAnyTag': 'Qualsiasi tag',
  'tickets.filterCompanies': 'Aziende',
  'tickets.filterAnyCompany': 'Qualsiasi azienda',
  'tickets.filterCreated': 'Creato',
  'tickets.filterResolvedAt': 'Risolto il',
  'tickets.filterClosedAt': 'Chiuso il',
  'tickets.filterDateFrom': '{label} dal',
  'tickets.filterDateTo': '{label} al',
  'tickets.filterDateTo2': 'al',
  'tickets.filterAny': 'Qualsiasi',
  'tickets.chipFieldStatus': 'Stato',
  'tickets.chipFieldPriority': 'Priorità',
  'tickets.chipFieldGroup': 'Gruppo',
  'tickets.chipFieldAssignee': 'Assegnatario',
  'tickets.chipValueGroup': 'Gruppo',
  'tickets.chipValueUnassigned': 'Non assegnato',

  'ticketDetail.back': 'Indietro',
  'ticketDetail.follow': 'Segui',
  'ticketDetail.following': 'Stai seguendo',
  'ticketDetail.hideActivities': 'Nascondi attività',
  'ticketDetail.activitiesButton': 'Attività',
  'ticketDetail.attachmentsCount': 'Allegati ({count})',
  'ticketDetail.threadAria': 'Conversazione del ticket',
  'ticketDetail.conversationsTabLabel': 'Conversazioni',
  'ticketDetail.activitiesTabLabel': 'Attività',
  'ticketDetail.noRepliesYet': 'Ancora nessuna risposta',
  'ticketDetail.noRepliesDescription': 'Usa l’editor qui sotto per rispondere al richiedente o aggiungere una nota interna.',
  'ticketDetail.privateNote': 'Nota privata',
  'ticketDetail.forward': 'Inoltra',
  'ticketDetail.uploadingAria': 'Caricamento in corso',
  'ticketDetail.uploadingProgress': 'Caricamento di {uploading} file su {total}…',
  'ticketDetail.uploadsFailed': '{count} caricamenti non riusciti',
  'ticketDetail.retry': 'Riprova',
  'ticketDetail.dismiss': 'Chiudi',
  'ticketDetail.noActivityYet': 'Ancora nessuna attività',
  'ticketDetail.noActivityDescription': 'Le modifiche a stato, agente e SLA saranno elencate qui man mano che il ticket avanza.',
  'ticketDetail.requester': 'Richiedente',
  'ticketDetail.properties': 'Proprietà',
  'ticketDetail.updating': 'Aggiornamento…',
  'ticketDetail.update': 'Aggiorna',
  'ticketDetail.tags': 'Tag',
  'ticketDetail.relationships': 'Relazioni',
  'ticketDetail.parentTicket': 'Ticket padre',
  'ticketDetail.unlink': 'Scollega',
  'ticketDetail.noParentTicket': 'Nessun ticket padre',
  'ticketDetail.childTicketsCount': 'Ticket figli ({count})',
  'ticketDetail.noChildTickets': 'Nessun ticket figlio',
  'ticketDetail.findTicket': 'Trova un ticket',
  'ticketDetail.ticketSearchPlaceholder': 'Numero o oggetto del ticket',
  'ticketDetail.searchButton': 'Cerca',
  'ticketDetail.setParent': 'Imposta come padre',
  'ticketDetail.mergeIntoAction': 'Unisci in',
  'ticketDetail.splitIntoChild': 'Dividi in un ticket figlio',
  'ticketDetail.newTicketSubjectPlaceholder': 'Oggetto del nuovo ticket',
  'ticketDetail.splitButton': 'Dividi',
  'ticketDetail.copyAttachments': 'Copia allegati',
  'ticketDetail.copyConversationHistory': 'Copia lo storico della conversazione',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'In pausa',
  'ticketDetail.editButton': 'Modifica',
  'ticketDetail.setResolutionDueDate': 'Imposta la scadenza di risoluzione',
  'ticketDetail.pickDateTime': 'Scegli data e ora',
  'ticketDetail.resolutionDueLabel': 'Scadenza di risoluzione',
  'ticketDetail.saveSla': 'Salva SLA',
  'ticketDetail.savingSla': 'Salvataggio…',
  'ticketDetail.noSlaPolicy': 'Nessuna policy SLA applicata a questo ticket.',
  'ticketDetail.firstResponse': 'Prima risposta',
  'ticketDetail.resolution': 'Risoluzione',
  'ticketDetail.done': 'Completato',
  'ticketDetail.pausedSince': 'In pausa dal {date}',
  'ticketDetail.escalation': 'Escalation',
  'ticketDetail.escalatedLevel2': 'Escalato (livello 2)',
  'ticketDetail.escalated': 'Escalato',
  'ticketDetail.dueDateOverridden': 'Scadenza modificata manualmente da un amministratore.',
  'ticketDetail.dates': 'Date',
  'ticketDetail.created': 'Creato',
  'ticketDetail.updated': 'Aggiornato',
  'ticketDetail.resolved': 'Risolto',
  'ticketDetail.closed': 'Chiuso',
  'ticketDetail.loadErrorTitle': 'Impossibile caricare questo ticket',
  'ticketDetail.notFound': 'Ticket non trovato',
  'ticketDetail.confirmMergeTitle': 'Unire il ticket #{source} in #{target}?',
  'ticketDetail.confirmMergeDescription': 'Il ticket corrente verrà chiuso. Questa azione non può essere annullata.',
  'ticketDetail.confirmMergeLabel': 'Unisci ticket',
  'ticketDetail.updateSuccess': 'Ticket aggiornato',
  'ticketDetail.updateError': 'Impossibile aggiornare il ticket',
  'ticketDetail.pickDateTitle': 'Scegli una data',
  'ticketDetail.pickDateDescription': 'Scegli una scadenza di risoluzione.',
  'ticketDetail.slaUpdateSuccess': 'SLA aggiornato',
  'ticketDetail.slaUpdateError': 'Impossibile aggiornare l’SLA',
  'ticketDetail.searchError': 'Impossibile cercare i ticket',
  'ticketDetail.parentUpdateError': 'Impossibile aggiornare il ticket padre',
  'ticketDetail.mergeSuccess': 'Unito in #{number}',
  'ticketDetail.mergeError': 'Impossibile unire il ticket',
  'ticketDetail.splitSuccess': 'Ticket diviso creato',
  'ticketDetail.splitError': 'Impossibile dividere il ticket',
  'ticketDetail.downloadError': 'Impossibile scaricare l’allegato',
  'ticketDetail.followSuccess': 'Ora segui il ticket',
  'ticketDetail.unfollowSuccess': 'Hai smesso di seguire il ticket',
  'ticketDetail.watcherError': 'Impossibile aggiornare lo stato di osservatore',
  'ticketDetail.fieldsLoadError': 'Impossibile caricare i campi del ticket',
  'ticketDetail.overdueBy': '{label} di ritardo',
  'ticketDetail.dueLeft': '{label} rimanenti',
  'ticketDetail.presetToday': 'Oggi',
  'ticketDetail.presetTomorrow': 'Domani',
  'ticketDetail.presetThisWeek': 'Questa settimana',
  'ticketDetail.presetNextWeek': 'Prossima settimana',
  'ticketDetail.presetThisMonth': 'Questo mese',
  'ticketDetail.eventTicketCreated': 'Ticket creato',
  'ticketDetail.eventStatusUpdated': 'Stato aggiornato',
  'ticketDetail.eventAgentUpdated': 'Agente aggiornato',
  'ticketDetail.eventSlaUpdated': 'SLA aggiornato',
  'ticketDetail.eventTicketMerged': 'Ticket unito',
  'ticketDetail.eventMergeReceived': 'Unione ricevuta',
  'ticketDetail.eventTicketSplit': 'Ticket diviso',
  'ticketDetail.eventUpdated': 'Aggiornato',
  'ticketDetail.eventSplitContentCopied': 'Contenuto della divisione copiato',
  'ticketDetail.eventReplySent': 'Risposta inviata',
  'ticketDetail.eventNoteAdded': 'Nota aggiunta',
  'ticketDetail.eventCustomerReplied': 'Il cliente ha risposto',
  'ticketDetail.eventTicketDeleted': 'Ticket eliminato',

  'ui.select': 'Seleziona…',
  'ui.any': 'Qualsiasi',
  'ui.typeToSearch': 'Digita per cercare…',
  'ui.noResults': 'Nessun risultato trovato',
  'ui.clearSelection': 'Cancella selezione',
  'ui.removeItem': 'Rimuovi {label}',
  'ui.pressEnterToUse': 'Premi Invio per usare questo valore',
  'ui.removeFilter': 'Rimuovi filtro {field}: {value}',
  'ui.removeTag': 'Rimuovi tag {label}',
  'ui.retry': 'Riprova',
  'ui.errorTitle': 'Impossibile caricare questo contenuto',
  'ui.errorMessage': 'Controlla la connessione e riprova.',
  'ui.reference': 'Riferimento: {id}',
  'ui.thisArea': 'quest’area',
  'ui.noAccess': 'Non hai accesso a {area}',
  'ui.noAccessHint': 'Chiedi a un amministratore di concederti l’autorizzazione necessaria.',
  'ui.actionFailed': 'Impossibile completare questa azione. Riprova.',
  'ui.slaPaused': 'SLA in pausa',
  'ui.filteredEmptyTitle': 'Nessun ticket corrisponde a questi filtri',
  'ui.filteredEmptyDescription': 'Prova a rimuovere un filtro o ad ampliare l’intervallo di date.',
  'ui.clearFilters': 'Cancella filtri',

  'pagination.noResults': 'Nessun risultato',
  'pagination.showing': 'Visualizzati {first}–{last} di {total}',
  'pagination.resultsPerPage': 'Risultati per pagina',
  'pagination.perPage': '{count} per pagina',
  'pagination.previous': 'Precedente',
  'pagination.next': 'Successiva',
  'pagination.previousAria': 'Pagina precedente',
  'pagination.nextAria': 'Pagina successiva',
  'pagination.pageOf': 'Pagina {page} di {total}',

  'status.open': 'Aperto',
  'status.to_be_prioritised': 'Da prioritizzare',
  'status.work_in_progress': 'In lavorazione',
  'status.assigned_to_ai_agent': 'Assegnato ad agente IA',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'In attesa',
  'status.awaiting_user_reply': 'In attesa di risposta dell’utente',
  'status.awaiting_resolution_confirmation': 'In attesa di conferma della risoluzione',
  'status.on_hold': 'In sospeso',
  'status.pending_production_release': 'In attesa di rilascio in produzione',
  'status.product_cr': 'CR di prodotto',
  'status.reopened': 'Riaperto',
  'status.issue_fixed': 'Problema risolto',
  'status.resolved': 'Risolto',
  'status.closed': 'Chiuso',
  'status.unknown': 'Sconosciuto',

  'priority.low': 'Bassa',
  'priority.medium': 'Media',
  'priority.high': 'Alta',
  'priority.urgent': 'Urgente',

  'source.email': 'Email',
  'source.portal': 'Portale',
  'source.phone': 'Telefono',
  'source.chat': 'Chat',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Chat web',
  'source.web_form': 'Modulo web',
  'source.forum': 'Forum',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Widget di feedback',
  'source.outbound_email': 'Email in uscita',
  'source.ecommerce': 'E-commerce',
  'source.bot': 'Bot',
  'source.instagram_message': 'Messaggio Instagram',
  'source.instagram_comment': 'Commento Instagram',
  'source.facebook_message': 'Messaggio Facebook',
  'source.facebook_comment': 'Commento Facebook',
  'source.mobile_chat_sdk': 'SDK chat mobile',
  'source.sms': 'SMS',
  'source.api': 'API',

  'savedViews.title': 'Viste salvate',
  'savedViews.saveCurrent': 'Salva i filtri correnti come vista',
  'savedViews.namePlaceholder': 'Nome della vista...',
  'savedViews.nameAria': 'Nome della vista',
  'savedViews.empty': 'Nessuna vista salvata. Applica dei filtri e salvali qui.',
  'savedViews.listAria': 'Elenco delle viste salvate',
  'savedViews.rename': 'Rinomina la vista "{name}"',
  'savedViews.delete': 'Elimina la vista "{name}"',

  'export.title': 'Esporta ticket',
  'export.loadError': 'Impossibile caricare l’elenco dei campi di esportazione.',
  'export.failed': 'Esportazione non riuscita. Riprova.',
  'export.pdfFailed': 'Esportazione PDF non riuscita. Riprova.',
  'export.fieldsSelectedOne': '{count} campo selezionato',
  'export.fieldsSelectedMany': '{count} campi selezionati',
  'export.fieldsTotalOne': '{count} campo in totale',
  'export.fieldsTotalMany': '{count} campi in totale',
  'export.selectAllFields': 'Seleziona tutti i campi',
  'export.exportingOne': 'Esportazione di 1 ticket selezionato.',
  'export.exportingMany': 'Esportazione di {count} ticket selezionati.',
  'export.pdfZip': 'Scarica come PDF (.zip, {count} file)',
  'export.pdf': 'Scarica come PDF',
  'export.pdfZipHint': 'Genera un PDF per ogni ticket e li comprime in un unico file ZIP da scaricare.',
  'export.pdfHint': 'Genera un unico PDF con le proprietà del ticket e la conversazione pubblica.',
  'export.formatLabel': 'Esporta come (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Caricamento dell’elenco dei campi…',
  'export.ticketFields': 'Campi del ticket',
  'export.contactFields': 'Campi del contatto',
  'export.companyFields': 'Campi dell’azienda',
  'export.exporting': 'Esportazione…',

  'newTicket.title': 'Crea ticket',
  'newTicket.description': 'Scegli un modulo salvato e compilane i campi.',
  'newTicket.form': 'Modulo ticket',
  'newTicket.noForms': 'Non ci sono moduli ticket disponibili. Configura un modulo prima di creare un ticket.',
  'newTicket.loadFormsError': 'Impossibile caricare i moduli ticket',
  'newTicket.loadFormError': 'Impossibile caricare il modulo ticket selezionato',
  'newTicket.addCc': 'Aggiungi CC',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': 'Rimuovi {name}',
  'newTicket.requesterRequired': 'Il richiedente è obbligatorio',
  'newTicket.subjectRequired': 'L’oggetto è obbligatorio',
  'newTicket.createFailed': 'Impossibile creare il ticket',
  'newTicket.noFormTitle': 'Nessun modulo ticket disponibile',
  'newTicket.noFormDescription': 'Crea un modulo ticket nelle Impostazioni, poi torna qui per aprire un ticket.',
  'newTicket.noFieldsTitle': 'Questo modulo non ha ancora campi',
  'newTicket.noFieldsDescription': 'Aggiungi dei campi al modulo nelle Impostazioni, poi ricarica questa pagina.',
  'newTicket.creating': 'Creazione in corso...',
  'newTicket.submit': 'Crea ticket',

  'fields.required': '{label} è obbligatorio',
  'fields.selectParentFirst': 'Seleziona prima un valore padre...',
  'fields.selectPlaceholder': 'Seleziona {label}...',
  'fields.enterPlaceholder': 'Inserisci {label}...',
  'fields.optionsLoadError': 'Impossibile caricare le opzioni di {label}',
  'fields.label.requester': 'Richiedente',
  'fields.label.subject': 'Oggetto',
  'fields.label.description': 'Descrizione',
  'fields.label.status': 'Stato',
  'fields.label.priority': 'Priorità',
  'fields.label.source': 'Origine',
  'fields.label.ticket_type': 'Tipo',
  'fields.label.agent': 'Agente',
  'fields.label.group': 'Gruppo',
  'fields.label.internal_agent': 'Agente interno',
  'fields.label.internal_group': 'Gruppo interno',
  'fields.label.company': 'Azienda',

  'editor.defaultPlaceholder': 'Scrivi qui...',
  'editor.ariaLabel': 'Editor di testo avanzato',
  'editor.toolbarAria': 'Formattazione del testo',
  'editor.bold': 'Grassetto (Ctrl+B)',
  'editor.italic': 'Corsivo (Ctrl+I)',
  'editor.underline': 'Sottolineato (Ctrl+U)',
  'editor.strikethrough': 'Barrato',
  'editor.heading1': 'Titolo 1',
  'editor.heading2': 'Titolo 2',
  'editor.textColor': 'Colore del testo',
  'editor.highlight': 'Evidenzia',
  'editor.bulletList': 'Elenco puntato',
  'editor.numberedList': 'Elenco numerato',
  'editor.blockquote': 'Citazione',
  'editor.codeBlock': 'Blocco di codice',
  'editor.insertLink': 'Inserisci link',
  'editor.insertImage': 'Inserisci immagine',
  'editor.insertTable': 'Inserisci tabella',
  'editor.mention': 'Menziona qualcuno',
  'editor.undo': 'Annulla (Ctrl+Z)',
  'editor.redo': 'Ripristina (Ctrl+Shift+Z)',
  'editor.attach': 'Allega file',
  'editor.noAgents': 'Nessun agente trovato',
  'editor.mentionSuggestions': 'Suggerimenti di menzione',
  'editor.dialogLinkTitle': 'Inserisci link',
  'editor.dialogImageTitle': 'Inserisci immagine',
  'editor.linkHint': 'Inserisci un URL HTTP(S), mailto, ancora o relativo.',
  'editor.imageHint': 'Inserisci l’URL HTTP(S) o relativo di un’immagine.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Inserisci un URL HTTP(S), mailto, ancora o relativo valido.',
  'editor.invalidImage': 'Inserisci un URL HTTP(S) o relativo valido per l’immagine.',
  'editor.selectTextForLink': 'Seleziona del testo prima di aggiungere un link.',
  'editor.imageInsertFailed': 'Non è stato possibile inserire l’immagine qui.',
  'editor.insertLinkAction': 'Inserisci link',
  'editor.insertImageAction': 'Inserisci immagine',

  'search.dialogAria': 'Ricerca globale',
  'search.placeholder': 'Cerca ticket, contatti...',
  'search.aria': 'Cerca',
  'search.close': 'Chiudi la ricerca',
  'search.noMatches': 'Nessun risultato per “{query}”',
  'search.noMatchesHint': 'Prova con un numero di ticket, l’email di un contatto o il nome di un’azienda.',
  'search.hintBefore': 'Digita almeno 2 caratteri per cercare. Premi',
  'search.hintAfter': 'per chiudere.',

  'td.system': 'Sistema',
  'td.actionCreatedTicket': 'ha creato il ticket',
  'td.actionUpdatedFields': 'ha aggiornato {fields}',
  'td.fieldStatus': 'stato',
  'td.fieldPriority': 'priorità',
  'td.fieldSource': 'origine',
  'td.fieldType': 'tipo',
  'td.fieldGroup': 'gruppo',
  'td.fieldAgent': 'agente',
  'td.fieldCompany': 'azienda',
  'td.fieldContact': 'contatto',
  'td.fieldSubject': 'oggetto',
  'td.fieldDescription': 'descrizione',
  'td.fieldProduct': 'prodotto',
  'td.fieldResolutionDue': 'scadenza di risoluzione',
  'td.fieldFirstResponseDue': 'scadenza della prima risposta',
  'td.fieldTags': 'tag',
  'td.fieldParentTicket': 'ticket padre',
  'td.eventCreated': '{actor} ha creato un nuovo ticket',
  'td.eventCreatedLinked': '{actor} ha creato un nuovo ticket e lo ha collegato a un ticket padre',
  'td.eventSplit': '{actor} ha diviso questo ticket e creato il ticket figlio{ref}',
  'td.eventMergeReceived': '{actor} ha unito un altro ticket in questo ticket{ref}',
  'td.eventMerged': '{actor} ha unito questo ticket in un altro ticket{ref}',
  'td.eventSplitCopied': '{actor} ha copiato {conversations} e {attachments}',
  'td.conversationsOne': '{count} conversazione',
  'td.conversationsMany': '{count} conversazioni',
  'td.attachmentsOne': '{count} allegato',
  'td.attachmentsMany': '{count} allegati',
  'td.eventUpdatedFields': '{actor} ha aggiornato {fields}',
  'td.invalidSlaState': 'Il server ha restituito uno stato SLA non valido.',
  'td.slaRefreshError': 'Impossibile aggiornare i timer SLA.',
  'td.descriptionUpdated': 'Descrizione aggiornata',
  'td.descriptionUpdateError': 'Impossibile aggiornare la descrizione',
  'td.descriptionUpdateFailed': 'Aggiornamento della descrizione non riuscito',
  'td.entryUpdated': 'Voce aggiornata',
  'td.entryUpdateError': 'Impossibile aggiornare la voce',
  'td.updateFailed': 'Aggiornamento non riuscito',
  'td.loadOlderError': 'Impossibile caricare le conversazioni precedenti',
  'td.loadFailed': 'Caricamento non riuscito',
  'td.slaUpdateFailed': 'Aggiornamento SLA non riuscito',
  'td.reasonTooLong': 'Il motivo deve contenere al massimo 500 caratteri.',
  'td.invalidDateTime': 'Scegli una data e un’ora valide.',
  'td.slaDeadlineUpdated': 'Scadenza SLA aggiornata',
  'td.slaConflict': 'Il ticket è cambiato mentre modificavi i dati SLA. Ricarica prima di riprovare.',
  'td.slaClearFailed': 'Rimozione SLA non riuscita',
  'td.slaTargetCleared': 'Obiettivo SLA rimosso',
  'td.slaClearError': 'Impossibile rimuovere l’obiettivo SLA',
  'td.noDescription': 'Nessuna descrizione aggiunta.',
  'td.editDescriptionAria': 'Modifica la descrizione del ticket',
  'td.download': 'Scarica',
  'td.downloadFile': 'Scarica {fileName}',
  'td.loadOlder': '↓ +{count} conversazione',
  'td.loadOlderMany': '↓ +{count} conversazioni',
  'td.edited': '(modificato)',
  'td.privateThread': 'Thread privato',
  'td.propertiesAria': 'Proprietà del ticket',
  'td.expandProperties': 'Espandi proprietà',
  'td.collapseProperties': 'Comprimi proprietà',
  'td.metric': 'Metrica',
  'td.firstResponseOption': 'Prima risposta',
  'td.resolutionOption': 'Risoluzione',
  'td.overrideHint': 'Imposta una scadenza manuale gestita dal server. Il motivo viene conservato nello storico SLA.',
  'td.deadline': 'Scadenza',
  'td.reasonOptional': 'Motivo (facoltativo)',
  'td.reasonPlaceholder': 'Eccezione approvata o contesto operativo',
  'td.clearResolutionOverride': 'Rimuovi modifica manuale della risoluzione',
  'td.clearEscalationTarget': 'Rimuovi obiettivo di escalation',
  'td.toolsAria': 'Strumenti del ticket e contatto',
  'td.ticketContext': 'Contesto del ticket',
  'td.knowledgeBase': 'Knowledge base',
  'td.shortcutsAria': 'Scorciatoie del contesto del ticket',
  'td.showContext': 'Mostra il contesto del ticket',
  'td.hideContext': 'Nascondi il contesto del ticket',
  'td.openRow': 'Apri {label}',
  'td.editTicket': 'Modifica ticket',
  'td.searchContactPlaceholder': 'Cerca contatto…',
  'td.describePlaceholder': 'Descrivi il problema…',
  'td.noAttachments': 'Nessun allegato',

  'tp.api.csrfUnavailable': 'Impossibile stabilire la protezione CSRF',
  'tp.api.noMfaChallenge': 'Nessuna verifica MFA attiva',
  'tp.api.noMfaSetup': 'Nessuna configurazione MFA attiva',
  'tp.api.noNewPasswordChallenge': 'Nessuna richiesta di nuova password attiva',
  'tp.articles.isLinkedAria': '{title} è collegato come soluzione',
  'tp.articles.linkAria': 'Collega {title} come soluzione',
  'tp.articles.linkAsSolution': 'Collega come soluzione',
  'tp.articles.linkedAsSolution': 'Collegato come soluzione',
  'tp.articles.none': 'Nessun articolo suggerito per questo ticket.',
  'tp.articles.title': 'Articoli suggeriti',
  'tp.articles.views': '{count} visualizzazioni',
  'tp.attachment.loadingPreview': 'Caricamento anteprima…',
  'tp.attachment.previewUnavailable': 'Anteprima non disponibile',
  'tp.charts.noData': 'Nessun dato del grafico per questo periodo.',
  'tp.charts.noRecords': 'Nessun record in questo periodo.',
  'tp.charts.period': 'Periodo',
  'tp.charts.showingTop': 'Visualizzati i primi {shown} di {total} segmenti.',
  'tp.common.cancel': 'Annulla',
  'tp.common.clear': 'Cancella',
  'tp.common.loading': 'Caricamento…',
  'tp.common.send': 'Invia',
  'tp.common.sending': 'Invio in corso…',
  'tp.common.system': 'Sistema',
  'tp.convActions.edit': 'Modifica',
  'tp.convActions.thread': 'Avvia una discussione',
  'tp.dashboard.new': 'Nuova',
  'tp.dashboard.select': 'Seleziona dashboard',
  'tp.forward.failed': 'Inoltro non riuscito',
  'tp.forward.forwarded': 'Ticket inoltrato',
  'tp.forward.forwarding': 'Inoltro in corso…',
  'tp.forward.forwardingMany': 'Inoltro di {count} conversazioni:',
  'tp.forward.forwardingOne': 'Inoltro di 1 conversazione:',
  'tp.forward.message': 'Messaggio',
  'tp.forward.messagePlaceholder': 'Aggiungi un messaggio (facoltativo)…',
  'tp.forward.noContacts': 'Nessun contatto trovato: digita un indirizzo email completo',
  'tp.forward.recipientEmail': 'Email del destinatario',
  'tp.forward.recipientInvalid': 'Inserisci un indirizzo email del destinatario valido',
  'tp.forward.recipientRequired': "L'email del destinatario è obbligatoria",
  'tp.forward.searchContact': "Cerca un contatto o digita l'email…",
  'tp.forward.title': 'Inoltra',
  'tp.forward.to': 'A',
  'tp.forward.useThisEmail': 'Premi Invio o fai clic su Inoltra per usare questa email',
  'tp.jira.addOptional': 'Aggiungi campi facoltativi',
  'tp.jira.createAndLink': 'Crea e collega issue',
  'tp.jira.createIssue': 'Crea issue',
  'tp.jira.createTitle': 'Crea issue Jira',
  'tp.jira.describePlaceholder': 'Descrivi il problema…',
  'tp.jira.description': 'Descrizione',
  'tp.jira.development': 'Sviluppo',
  'tp.jira.enterDevelopment': 'Inserisci sviluppo',
  'tp.jira.hideOptional': 'Nascondi campi facoltativi',
  'tp.jira.issueId': 'ID issue',
  'tp.jira.issueSummary': 'Riepilogo issue',
  'tp.jira.issueType': 'Tipo di issue *',
  'tp.jira.lastSync': 'Ultima sincronizzazione: {error}',
  'tp.jira.linkIssue': 'Collega issue',
  'tp.jira.linkTitle': 'Collega issue Jira',
  'tp.jira.linkedIssues': 'Issue collegate',
  'tp.jira.linkedIssuesHint': 'Usa le chiavi delle issue Jira separate da virgole.',
  'tp.jira.linkedIssuesPlaceholder': 'es. SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Caricamento campi Jira…',
  'tp.jira.loadingIssueTypes': 'Caricamento tipi di issue…',
  'tp.jira.loadingProjects': 'Caricamento progetti Jira…',
  'tp.jira.loadingUsers': 'Caricamento utenti Jira…',
  'tp.jira.noLinks': 'Nessuna issue Jira ancora collegata a questo ticket.',
  'tp.jira.noneFound': 'Nessuna issue Jira trovata.',
  'tp.jira.notAvailableProject': 'Non disponibile per questo progetto',
  'tp.jira.projects': 'Progetti *',
  'tp.jira.refresh': 'Aggiorna',
  'tp.jira.refreshFields': 'Aggiorna campi Jira',
  'tp.jira.reporter': 'Segnalatore',
  'tp.jira.requestFailed': 'Richiesta Jira non riuscita. Riprova.',
  'tp.jira.searchBy': 'Cerca per:',
  'tp.jira.searchIssue': 'Cerca issue',
  'tp.jira.searchIssuePlaceholder': 'Cerca issue…',
  'tp.jira.searchUsers': 'Cerca utenti Jira',
  'tp.jira.searching': 'Ricerca in Jira…',
  'tp.jira.selectIssueType': 'Seleziona un tipo di issue',
  'tp.jira.selectProject': 'Seleziona un progetto',
  'tp.jira.summary': 'Riepilogo *',
  'tp.jira.syncOff': 'Sincronizzazione disattivata',
  'tp.jira.syncOn': 'Sincronizzazione attiva',
  'tp.jira.syncStatus': 'Sincronizza lo stato del ticket con Jira',
  'tp.jira.unassigned': 'Non assegnato',
  'tp.jira.unlink': 'Scollega',
  'tp.jira.unlinkConfirm': 'Scollega issue',
  'tp.jira.unlinkDescription': "Questa azione rimuove il collegamento dal ticket ma non elimina l'issue Jira.",
  'tp.jira.unlinkTitle': 'Scollegare {key}?',
  'tp.jira.untitled': 'Issue Jira senza titolo',
  'tp.layout.loadingPage': 'Caricamento pagina…',
  'tp.notFound.goToDashboard': 'Vai alla dashboard',
  'tp.notFound.title': 'Pagina non trovata',
  'tp.portal.brand': 'SuzukiDesk Support',
  'tp.portal.customer': 'Cliente',
  'tp.reply.addNote': 'Aggiungi nota',
  'tp.reply.attachmentNotAdded': 'Allegato non aggiunto',
  'tp.reply.clickToExpand': 'Fai clic per espandere',
  'tp.reply.collapsedNote': 'Aggiungi una nota interna…',
  'tp.reply.collapsedReply': 'Scrivi una risposta o una nota…',
  'tp.reply.conversationType': 'Tipo di conversazione',
  'tp.reply.failedToSend': 'Invio non riuscito',
  'tp.reply.markNoteAs': 'Contrassegna la nota come',
  'tp.reply.notVisibleToContact': 'Non visibile al contatto',
  'tp.reply.notVisibleToContacts': 'Non visibile ai contatti',
  'tp.reply.noteAdded': 'Nota aggiunta',
  'tp.reply.notifyTo': 'Notifica a',
  'tp.reply.placeholderPrivateNote': 'Aggiungi una nota privata...',
  'tp.reply.placeholderPublicNote': 'Aggiungi una nota pubblica visibile al richiedente...',
  'tp.reply.placeholderReply': 'Scrivi la tua risposta...',
  'tp.reply.private': 'Privata',
  'tp.reply.public': 'Pubblica',
  'tp.reply.removeFile': 'Rimuovi {name}',
  'tp.reply.replySent': 'Risposta inviata',
  'tp.reply.searchAgentsToNotify': 'Cerca gli agenti da notificare…',
  'tp.reply.sendReply': 'Invia risposta',
  'tp.reply.sending': 'Invio in corso...',
  'tp.reply.tabNote': 'Nota',
  'tp.reply.tabReply': 'Risposta',
  'tp.reply.uploadAttachment': 'Carica allegato',
  'tp.reply.visibleToContact': 'Visibile al contatto',
  'tp.reply.visibleToContacts': 'Visibile ai contatti',
  'tp.sla.breached': 'Violato',
  'tp.sla.cleared': 'Annullato',
  'tp.sla.configErrorNoDeadline': 'Errore di configurazione SLA. Nessuna scadenza viene dedotta.',
  'tp.sla.configurationError': 'Errore di configurazione',
  'tp.sla.couldNotLoad': 'Impossibile caricare i timer SLA',
  'tp.sla.done': 'Completato',
  'tp.sla.dueIn': 'Scade tra {duration}',
  'tp.sla.dueLine': 'Scadenza: {date}',
  'tp.sla.dueNow': 'Scade ora',
  'tp.sla.escalated': 'Escalation eseguita',
  'tp.sla.firstResponse': 'Prima risposta',
  'tp.sla.invalidDeadline': 'Scadenza non valida',
  'tp.sla.mayBeStale': 'I timer SLA potrebbero non essere aggiornati',
  'tp.sla.noActiveCycle': 'Nessun ciclo SLA attivo.',
  'tp.sla.noDeadline': 'Nessuna scadenza',
  'tp.sla.noMetrics': 'Nessuna metrica SLA disponibile per questo ciclo.',
  'tp.sla.noPolicy': 'Nessuna policy SLA applicata a questo ticket.',
  'tp.sla.notConfigured': 'Non configurato',
  'tp.sla.notStarted': 'Non avviato',
  'tp.sla.overdueBy': 'In ritardo di {duration}',
  'tp.sla.overridden': 'Sovrascritto',
  'tp.sla.overrideReason': 'Motivo della sovrascrittura: {reason}',
  'tp.sla.paused': 'In pausa',
  'tp.sla.refreshing': 'Aggiornamento dei timer SLA in corso…',
  'tp.sla.resolution': 'Risoluzione',
  'tp.sla.stopsSla': 'Ferma SLA',
  'tp.thread.empty': 'Non è stato ancora inviato nulla. Il tuo primo messaggio avvierà questa discussione privata.',
  'tp.thread.messageFailed': 'Invio del messaggio non riuscito',
  'tp.thread.privateThread': 'Discussione privata',
  'tp.thread.replyPlaceholder': 'Rispondi nella discussione…',
  'tp.thread.someone': 'Qualcuno',
  'tp.thread.startPrivateThread': 'Avvia una discussione privata',
  'tp.thread.startedBy': '{name} ha avviato questa discussione',
  'tp.thread.unableToSend': 'Impossibile inviare il messaggio',
  'tp.ui.breadcrumb': 'Percorso di navigazione',
  'tp.ui.closePanel': 'Chiudi pannello',
  'tp.ui.dismiss': 'Chiudi {title}',

  'dir.loadError': 'Impossibile caricare i dati. Riprova.',
  'dir.contacts.description': 'Contatti dei clienti e relativa cronologia di assistenza.',
  'dir.contacts.searchAria': 'Cerca contatti',
  'dir.contacts.count': '{count} contatti',
  'dir.contacts.noMatch': 'Nessun contatto corrisponde alla ricerca',
  'dir.contacts.none': 'Ancora nessun contatto',
  'dir.contacts.noneDescription': 'I contatti compaiono qui quando i clienti iniziano a inviare ticket.',
  'dir.company': 'Azienda',
  'dir.unnamedContact': 'Contatto senza nome',
  'dir.contact': 'Contatto',
  'dir.contactNotFound': 'Contatto non trovato.',
  'dir.confirmDeleteContactTitle': 'Eliminare “{name}”?',
  'dir.thisContact': 'questo contatto',
  'dir.confirmDeleteContactDescription': 'I contatti con ticket verranno disattivati anziché eliminati definitivamente.',
  'dir.deleteContact': 'Elimina contatto',
  'dir.editProfile': 'Modifica profilo',
  'dir.profile': 'Profilo',
  'dir.firstName': 'Nome',
  'dir.lastName': 'Cognome',
  'dir.phone': 'Telefono',
  'dir.timezone': 'Fuso orario',
  'dir.emailLabel': 'Email:',
  'dir.phoneLabel': 'Telefono:',
  'dir.companyLabel': 'Azienda:',
  'dir.timezoneLabel': 'Fuso orario:',
  'dir.recentTickets': 'Ticket recenti',
  'dir.noTicketsYet': 'Ancora nessun ticket',
  'dir.contactTicketsDescription': 'I ticket aperti da questo contatto verranno elencati qui.',
  'dir.ticket': 'Ticket',
  'dir.subject': 'Oggetto',
  'dir.status': 'Stato',
  'dir.created': 'Creato',
  'dir.companies.description': 'Organizzazioni collegate ai contatti dei clienti e ai ticket.',
  'dir.companies.add': 'Aggiungi azienda',
  'dir.companies.domain': 'Dominio',
  'dir.companies.create': 'Crea azienda',
  'dir.companies.searchAria': 'Cerca aziende',
  'dir.companies.searchPlaceholder': 'Cerca aziende o domini',
  'dir.companies.noMatch': 'Nessuna azienda corrisponde alla ricerca',
  'dir.companies.addFirst': 'Aggiungi la tua prima azienda',
  'dir.companies.tryDifferent': 'Prova con un altro nome o dominio aziendale.',
  'dir.companies.useForm': 'Usa il modulo accanto all’elenco per creare un’azienda.',
  'dir.companies.contacts': 'Contatti',
  'dir.companies.tickets': 'Ticket',
  'dir.companies.notFound': 'Azienda non trovata.',
  'dir.companies.confirmDeleteTitle': 'Eliminare “{name}”?',
  'dir.companies.thisCompany': 'questa azienda',
  'dir.companies.confirmDeleteDescription': 'L’azienda non deve avere contatti o ticket prima di poter essere eliminata.',
  'dir.companies.delete': 'Elimina azienda',
  'dir.companies.noDomain': 'Nessun dominio configurato',
  'dir.companies.contactsCount': 'Contatti ({count})',
  'dir.companies.ticketsCount': 'Ticket ({count})',
  'dir.companies.noContactsDescription': 'Aggiungi un contatto e collegalo a questa azienda per vederlo qui.',
  'dir.companies.noTicketsDescription': 'I ticket aperti dai contatti di questa azienda verranno elencati qui.',
  'dir.trendsCreatedHour': 'Data di creazione - Ora del giorno',
  'dir.reports.loadError': 'Impossibile caricare questo report. Riprova.',
  'dir.reports.volume': 'Volume dei ticket',
  'dir.reports.sla': 'Conformità SLA',
  'dir.reports.agents': 'Prestazioni degli agenti',
  'dir.reports.csat': 'Soddisfazione dei clienti',
  'dir.reports.rca': 'Analisi delle cause radice',
  'dir.reports.descVolume': 'Scopri da dove arrivano i ticket e come si muovono nel ciclo di vita.',
  'dir.reports.descSla': 'Monitora gli obiettivi di risposta e risoluzione sull’attività di assistenza accessibile.',
  'dir.reports.descAgents': 'Confronta carico di lavoro, risultati, risposte e tempi medi di gestione per agente.',
  'dir.reports.descCsat': 'Leggi il sentiment dei clienti senza confondere il volume di risposte con il tasso di soddisfazione.',
  'dir.reports.descRca': 'Individua le cause radice standardizzate dietro la domanda di ticket.',
  'dir.reports.noPayload': 'Nessun dato del report è stato restituito per questo periodo.',
  'dir.reports.refresh': 'Aggiorna',
  'dir.reports.report': 'Report',
  'dir.reports.from': 'Da',
  'dir.reports.to': 'A',
  'dir.reports.maxRange': 'Intervallo massimo: 90 giorni · l’ambito segue le autorizzazioni del tuo account.',
  'dir.reports.unclassified': 'Non classificato',
  'dir.reports.ticketsInPeriod': 'Ticket nel periodo',
  'dir.reports.ticketsInPeriodDetail': 'Ticket accessibili restituiti dal report',
  'dir.reports.created': 'Creati',
  'dir.reports.createdDetail': 'Sull’asse temporale selezionato',
  'dir.reports.resolved': 'Risolti',
  'dir.reports.resolvedDetail': '{percent}% del volume creato',
  'dir.reports.noCreated': 'Nessun ticket creato',
  'dir.reports.reopened': 'Riaperti',
  'dir.reports.reopenedDetail': 'Eventi del ciclo di vita, non ticket univoci',
  'dir.reports.dailyPulse': 'Andamento giornaliero',
  'dir.reports.volumeByDate': 'Volume dei ticket per data',
  'dir.reports.volumeByDateDescription': 'Le righe sparse del backend vengono estese in un asse temporale completo con zeri.',
  'dir.reports.createdTickets': 'Ticket creati',
  'dir.reports.createdVolumeAria': 'Volume dei ticket creati per data',
  'dir.reports.lifecycle': 'Ciclo di vita',
  'dir.reports.lifecycleTitle': 'Creati, risolti, riaperti',
  'dir.reports.lifecycleDescription': 'Una vista a tre linee del movimento nel ciclo di vita dei ticket.',
  'dir.reports.lifecycleAria': 'Eventi del ciclo di vita dei ticket per data',
  'dir.reports.dimensions': 'Dimensioni',
  'dir.reports.whereConcentrated': 'Dove si concentra il volume',
  'dir.reports.topEight': 'Primi otto segmenti mostrati per pannello',
  'dir.reports.status': 'Stato',
  'dir.reports.statusDescription': 'Stato attuale del ticket',
  'dir.reports.priority': 'Priorità',
  'dir.reports.priorityDescription': 'Distribuzione delle priorità dei ticket',
  'dir.reports.group': 'Gruppo',
  'dir.reports.groupDescription': 'Gruppi di instradamento',
  'dir.reports.agent': 'Agente',
  'dir.reports.agentDescription': 'Responsabile assegnato',
  'dir.reports.product': 'Prodotto',
  'dir.reports.productDescription': 'Distribuzione per prodotto',
  'dir.reports.country': 'Paese',
  'dir.reports.countryDescription': 'Da campi paese standardizzati',
  'dir.reports.noRecords': 'Nessun record in questo periodo.',
  'dir.reports.slaSummary': '{rate} · {met} di {total} rispettati',
  'dir.reports.noSlaSegments': 'Ancora nessun segmento SLA',
  'dir.reports.noSlaSegmentsDescription': 'Non ci sono record SLA applicabili per questa dimensione nel periodo selezionato.',
  'dir.reports.segment': 'Segmento',
  'dir.reports.firstResponse': 'Prima risposta',
  'dir.reports.resolution': 'Risoluzione',
  'dir.reports.avgFirstResponse': 'Prima risposta media',
  'dir.reports.avgResolution': 'Risoluzione media',
  'dir.reports.fromTicketMetric': 'Da TicketMetric',
  'dir.reports.slaLens': 'Prospettiva SLA',
  'dir.reports.performanceBySegment': 'Prestazioni per segmento',
  'dir.reports.slaRatesNote': 'I tassi usano solo i record con un obiettivo SLA applicabile. Le durate sono tempi medi trascorsi.',
  'dir.reports.slaDimensionAria': 'Dimensione dell’analisi SLA',
  'dir.reports.rosterSignal': 'Indicatore del team',
  'dir.reports.agentPerformance': 'Prestazioni degli agenti',
  'dir.reports.agentPerformanceDescription': 'Sono inclusi tutti gli agenti attivi, anche quelli senza attività.',
  'dir.reports.filterAgentsAria': 'Filtra agenti',
  'dir.reports.filterAgentsPlaceholder': 'Filtra per agente o email',
  'dir.reports.matchingAgents': '{count} agenti corrispondenti',
  'dir.reports.activeAgents': '{count} agenti attivi',
  'dir.reports.sortedBy': 'ordinati per {key} {direction}',
  'dir.reports.asc': 'crescente',
  'dir.reports.desc': 'decrescente',
  'dir.reports.noAgentsMatch': 'Nessun agente corrisponde al filtro',
  'dir.reports.assigned': 'Assegnati',
  'dir.reports.replies': 'Risposte',
  'dir.reports.csatScore': 'Punteggio CSAT',
  'dir.reports.csatScoreDetail': 'Valutazioni di 4 o 5',
  'dir.reports.averageRating': 'Valutazione media',
  'dir.reports.averageRatingDetail': 'Su tutti i sondaggi valutati',
  'dir.reports.ratedSurveys': 'Sondaggi valutati',
  'dir.reports.ratedSurveysDetail': 'Nel periodo selezionato',
  'dir.reports.satisfied': 'Soddisfatti',
  'dir.reports.satisfiedDetail': 'Risposte positive',
  'dir.reports.responseTrend': 'Andamento delle risposte',
  'dir.reports.surveyVolume': 'Volume dei sondaggi per data',
  'dir.reports.surveyVolumeDescription': 'Il backend restituisce il numero di risposte per data; non è un punteggio giornaliero. Qui sotto sono campionate le ultime 100 risposte.',
  'dir.reports.surveyResponses': 'Risposte ai sondaggi',
  'dir.reports.surveyVolumeAria': 'Volume delle risposte ai sondaggi CSAT per data',
  'dir.reports.responsesByGroup': 'Risposte per gruppo',
  'dir.reports.responsesByGroupDescription': 'Numero di risposte ai sondaggi, non un tasso di soddisfazione del gruppo',
  'dir.reports.responsesByAgent': 'Risposte per agente',
  'dir.reports.responsesByAgentDescription': 'Numero di risposte ai sondaggi, non un tasso di soddisfazione dell’agente',
  'dir.reports.customerVoice': 'Voce del cliente',
  'dir.reports.latestSurveys': 'Ultime risposte ai sondaggi',
  'dir.reports.boundedSample': 'Campione limitato · {count} su un massimo di 100',
  'dir.reports.latestSurveysNote': 'Le risposte più recenti restituite dall’API di reportistica. Usa questa tabella per una lettura rapida, non come esportazione completa.',
  'dir.reports.noSurveys': 'Nessuna risposta ai sondaggi',
  'dir.reports.noSurveysDescription': 'Le risposte CSAT compariranno qui quando i clienti valuteranno un ticket risolto.',
  'dir.reports.rating': 'Valutazione',
  'dir.reports.comment': 'Commento',
  'dir.reports.received': 'Ricevuto',
  'dir.reports.ratingOutOf': '{rating} su 5',
  'dir.reports.noComment': 'Nessun commento',
  'dir.reports.rcaEyebrow': 'Analisi delle cause radice',
  'dir.reports.rcaTitle': 'Perché vengono aperti i ticket',
  'dir.reports.rcaDescription': 'Categoria e sottocategoria sono aggregati indipendenti dei campi personalizzati standardizzati dei ticket.',
  'dir.reports.rcaDimensionAria': 'Dimensione RCA',
  'dir.reports.category': 'Categoria',
  'dir.reports.subcategory': 'Sottocategoria',
  'dir.reports.rcaEmpty': 'Nessun valore di causa radice registrato per questo periodo.',
  'dir.kb.articleLoadError': 'Impossibile caricare l’articolo.',
  'dir.kb.articleNotFound': 'Articolo non trovato.',
  'dir.kb.retry': 'Riprova',
  'dir.kb.title': 'Knowledge Base',
  'dir.kb.breadcrumb': 'Knowledge base',
  'dir.kb.description': '{articles} articoli in {folders} cartelle',
  'dir.kb.newArticle': 'Nuovo articolo',
  'dir.kb.editArticle': 'Modifica articolo',
  'dir.kb.sectionsAria': 'Sezioni della knowledge base',
  'dir.kb.tabArticles': 'Articoli',
  'dir.kb.tabStructure': 'Categorie e cartelle',
  'dir.kb.folderFilterAria': 'Filtro cartelle',
  'dir.kb.allArticles': 'Tutti gli articoli ({count})',
  'dir.kb.writeFirst': 'Scrivi il tuo primo articolo',
  'dir.kb.writeFirstDescription': 'Usa Nuovo articolo per aggiungere contenuti a questa cartella.',
  'dir.kb.byAuthor': 'di {name}',
  'dir.kb.views': '{count} visualizzazioni',
  'dir.kb.published': 'Pubblicato',
  'dir.kb.draft': 'Bozza',
  'dir.kb.publish': 'Pubblica',
  'dir.kb.unpublish': 'Annulla pubblicazione',
  'dir.kb.noFolders': 'Nessuna cartella in questa categoria',
  'dir.kb.noFoldersDescription': 'Aggiungi una cartella per iniziare a raggruppare gli articoli.',
  'dir.kb.articlesCount': '{count} articoli',
  'dir.kb.fieldTitle': 'Titolo',
  'dir.kb.folder': 'Cartella',
  'dir.kb.selectFolder': 'Seleziona cartella',
  'dir.kb.content': 'Contenuto',
  'dir.kb.contentPlaceholder': 'Scrivi il contenuto dell’articolo...',
  'dir.kb.tags': 'Tag (separati da virgola)',
  'dir.kb.attachments': 'Allegati',
  'dir.kb.download': 'Scarica',
  'dir.kb.downloadFile': 'Scarica {name}',
  'dir.kb.remove': 'Rimuovi',
  'dir.kb.removeFile': 'Rimuovi {name}',
  'dir.kb.noAttachments': 'Ancora nessun allegato.',
  'dir.kb.uploadAria': 'Carica allegato',
  'dir.kb.uploading': 'Caricamento...',
  'dir.kb.addFile': 'Aggiungi file',
  'dir.kb.confirmDeleteTitle': 'Eliminare l’articolo?',
  'dir.kb.confirmDeleteDescription': 'Questo articolo, pubblicato o in bozza, verrà eliminato definitivamente.',
  'dir.kb.confirmDeleteLabel': 'Elimina articolo',
  'dir.kb.confirmRemoveTitle': 'Rimuovere l’allegato?',
  'dir.kb.confirmRemoveDescription': 'Il file verrà rimosso definitivamente da questo articolo.',
  'dir.kb.confirmRemoveLabel': 'Rimuovi allegato',
  'dir.reports.rangeInvalid': 'Scegli date di inizio e fine valide.',
  'dir.reports.rangeOrder': 'La data di fine deve essere uguale o successiva alla data di inizio.',
  'dir.reports.rangeMax': 'I report supportano un intervallo massimo di 90 giorni.',

  'adm.active': 'Attivo',
  'adm.auto.action.add_tag': 'aggiungi tag',
  'adm.auto.action.assign_agent': 'assegna agente',
  'adm.auto.action.assign_group': 'assegna gruppo',
  'adm.auto.action.send_email': 'invia email',
  'adm.auto.action.send_notification': 'invia notifica',
  'adm.auto.action.set_priority': 'imposta priorità',
  'adm.auto.action.set_status': 'imposta stato',
  'adm.auto.actions': 'Azioni',
  'adm.auto.addAction': '+ Aggiungi azione',
  'adm.auto.addCondition': '+ Aggiungi condizione',
  'adm.auto.addRule': 'Aggiungi regola',
  'adm.auto.colApplied': 'Azioni applicate',
  'adm.auto.colDate': 'Data',
  'adm.auto.colMatched': 'Corrisponde',
  'adm.auto.colSubject': 'Oggetto',
  'adm.auto.colTicket': 'Ticket',
  'adm.auto.conditions': 'Condizioni',
  'adm.auto.confirmDesc': 'Questa regola smetterà di funzionare immediatamente e non potrà essere ripristinata.',
  'adm.auto.confirmLabel': 'Elimina regola',
  'adm.auto.confirmTitle': 'Eliminare la regola di automazione?',
  'adm.auto.countMany': '{count} regole di automazione',
  'adm.auto.countOne': '{count} regola di automazione',
  'adm.auto.create': 'Crea',
  'adm.auto.createFirst': 'Crea la tua prima regola di automazione',
  'adm.auto.createFirstDesc': 'Usa Aggiungi regola per instradare, assegnare priorità o notificare automaticamente.',
  'adm.auto.deleteFailed': 'Eliminazione non riuscita',
  'adm.auto.description': 'Le regole vengono eseguite in sequenza in base alla posizione. Le condizioni all’interno di una regola sono in AND.',
  'adm.auto.editRule': 'Modifica regola di automazione',
  'adm.auto.execFailed': 'Impossibile caricare le esecuzioni',
  'adm.auto.field.assigneeId': 'assegnatario',
  'adm.auto.field.companyId': 'azienda',
  'adm.auto.field.groupId': 'gruppo',
  'adm.auto.field.priority': 'priorità',
  'adm.auto.field.requesterId': 'richiedente',
  'adm.auto.field.source': 'origine',
  'adm.auto.field.status': 'stato',
  'adm.auto.field.subject': 'oggetto',
  'adm.auto.field.ticketTypeId': 'tipo di ticket',
  'adm.auto.hits': 'Esecuzioni',
  'adm.auto.loadFailed': 'Impossibile caricare le regole di automazione',
  'adm.auto.log': 'Log',
  'adm.auto.logTitle': 'Log di esecuzione — {name}',
  'adm.auto.moveDown': 'Sposta giù',
  'adm.auto.moveUp': 'Sposta su',
  'adm.auto.newRule': 'Nuova regola di automazione',
  'adm.auto.no': 'No',
  'adm.auto.noRuns': 'Nessuna esecuzione registrata',
  'adm.auto.noRunsDesc': 'Le esecuzioni compariranno qui la prima volta che questa regola corrisponde a un ticket.',
  'adm.auto.op.contains': 'contiene',
  'adm.auto.op.ends_with': 'termina con',
  'adm.auto.op.greater_than': 'maggiore di',
  'adm.auto.op.in': 'in',
  'adm.auto.op.is': 'è',
  'adm.auto.op.is_empty': 'è vuoto',
  'adm.auto.op.is_not': 'non è',
  'adm.auto.op.is_not_empty': 'non è vuoto',
  'adm.auto.op.less_than': 'minore di',
  'adm.auto.op.not_contains': 'non contiene',
  'adm.auto.op.not_in': 'non in',
  'adm.auto.op.starts_with': 'inizia con',
  'adm.auto.reorderFailed': 'Riordino non riuscito',
  'adm.auto.saveFailed': 'Salvataggio non riuscito',
  'adm.auto.stopProcessing': 'Interrompi l’elaborazione delle regole successive',
  'adm.auto.title': 'Regole di automazione',
  'adm.auto.toggleFailed': 'Modifica dello stato non riuscita',
  'adm.auto.trigger': 'Trigger *',
  'adm.auto.trigger.ticket_creation': 'Creazione del ticket',
  'adm.auto.trigger.ticket_update': 'Aggiornamento del ticket',
  'adm.auto.trigger.time_trigger': 'Basato sul tempo',
  'adm.auto.triggerCol': 'Trigger',
  'adm.auto.valuePlaceholder': 'Valore',
  'adm.auto.yes': 'Sì',
  'adm.close': 'Chiudi',
  'adm.deleting': 'Eliminazione…',
  'adm.description': 'Descrizione',
  'adm.descriptionLabel': 'Descrizione',
  'adm.edit': 'Modifica',
  'adm.email.addChannel': 'Aggiungi canale',
  'adm.email.addTitle': 'Aggiungi canale email',
  'adm.email.colEmail': 'Email',
  'adm.email.colReplyTo': 'Risposta a',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Questo canale non sarà più disponibile per la posta di supporto.',
  'adm.email.confirmLabel': 'Elimina canale',
  'adm.email.confirmTitle': 'Eliminare il canale email?',
  'adm.email.countMany': '{count} canali email',
  'adm.email.countOne': '{count} canale email',
  'adm.email.create': 'Crea',
  'adm.email.createFirst': 'Aggiungi il tuo primo canale email',
  'adm.email.createFirstDesc': 'Usa Aggiungi canale per collegare un indirizzo di supporto in modo che le risposte arrivino a questo desk.',
  'adm.email.default': 'Predefinito',
  'adm.email.defaultChannel': 'Canale predefinito',
  'adm.email.deleteFailed': 'Eliminazione non riuscita',
  'adm.email.description': 'Gestisci gli indirizzi email in entrata e in uscita, la configurazione SMTP e le impostazioni di risposta.',
  'adm.email.editTitle': 'Modifica canale email',
  'adm.email.emailAddress': 'Indirizzo email *',
  'adm.email.loadFailed': 'Impossibile caricare le configurazioni email',
  'adm.email.outbound': 'SMTP in uscita',
  'adm.email.replyTo': 'Indirizzo di risposta',
  'adm.email.replyToPh': '(predefinito: indirizzo email)',
  'adm.email.saveFailed': 'Salvataggio non riuscito',
  'adm.email.sesGlobal': 'SES (globale)',
  'adm.email.smtpHost': 'Host SMTP',
  'adm.email.smtpHostPh': 'es. email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'Password SMTP',
  'adm.email.smtpPort': 'Porta SMTP',
  'adm.email.smtpUser': 'Utente SMTP',
  'adm.email.title': 'Canali email',
  'adm.groups.aboutBody': 'I membri determinano quali agenti vedono per impostazione predefinita i ticket di questo gruppo. L’orario lavorativo regola i tempi SLA dei ticket instradati qui e il contatto di escalation viene avvisato, oltre all’assegnatario, quando un ticket supera il proprio SLA.',
  'adm.groups.aboutTitle': 'Informazioni su questo gruppo',
  'adm.groups.accountDefault': 'Predefinito dell’account',
  'adm.groups.activeAgentMany': '{count} agenti attivi',
  'adm.groups.activeAgentOne': '{count} agente attivo',
  'adm.groups.activeAgents': 'Agenti attivi',
  'adm.groups.addMember': 'Aggiungi membro',
  'adm.groups.assignment': 'Assegnazione',
  'adm.groups.autoAssign': 'Assegnazione automatica',
  'adm.groups.autoAssignNote': 'In questo prodotto l’assegnazione dei ticket è sempre manuale: non esiste un instradamento round-robin o basato sul carico. Questa opzione non cambia la situazione.',
  'adm.groups.businessHours': 'Orario lavorativo',
  'adm.groups.colGroup': 'Gruppo',
  'adm.groups.confirmDesc': 'I ticket e i modelli che usano questo gruppo devono prima essere riassegnati.',
  'adm.groups.confirmLabel': 'Elimina gruppo',
  'adm.groups.confirmTitle': 'Eliminare “{name}”?',
  'adm.groups.createFirst': 'Crea il tuo primo gruppo',
  'adm.groups.defaultHours': 'Orario predefinito',
  'adm.groups.editAria': 'Modifica {name}',
  'adm.groups.editGroup': 'Modifica gruppo',
  'adm.groups.escalateHelp': 'Aggiunto come destinatario delle notifiche quando un ticket di questo gruppo supera il proprio SLA.',
  'adm.groups.escalateTo': 'Escalation a',
  'adm.groups.escalatesTo': 'Escalation a',
  'adm.groups.escalatesToName': 'Escalation a {name}',
  'adm.groups.escalationBody': 'Quando un ticket di questo gruppo supera il proprio SLA, il contatto di escalation viene aggiunto come destinatario delle notifiche insieme all’assegnatario e ai membri del gruppo.',
  'adm.groups.escalationTitle': 'Contatto di escalation',
  'adm.groups.hoursHelp': 'Usato per i calcoli SLA sui ticket di questo gruppo.',
  'adm.groups.manageAgents': 'Gestisci agenti',
  'adm.groups.manageHours': 'Gestisci orari lavorativi',
  'adm.groups.manual': 'Manuale',
  'adm.groups.manualBody': 'In questo prodotto l’assegnazione è manuale: non esiste un’assegnazione automatica round-robin o basata sul carico. L’opzione "Assegnazione automatica" di un gruppo influisce solo sul fatto che i nuovi ticket del gruppo restino non assegnati o seguano una regola di instradamento esistente; gli agenti prendono in carico e passano i ticket manualmente.',
  'adm.groups.manualTitle': 'Assegnazione manuale',
  'adm.groups.memberMany': '{count} membri',
  'adm.groups.memberOne': '{count} membro',
  'adm.groups.members': 'Membri',
  'adm.groups.newGroup': 'Nuovo gruppo',
  'adm.groups.noEscalation': 'Nessun contatto di escalation',
  'adm.groups.noMatch': 'Nessun gruppo corrisponde alla ricerca',
  'adm.groups.noMembers': 'Ancora nessun membro',
  'adm.groups.noMembersDesc': 'Scegli un agente attivo qui sopra e seleziona Aggiungi membro.',
  'adm.groups.remove': 'Rimuovi',
  'adm.groups.routing': 'Instradamento',
  'adm.groups.routingMethod': 'Metodo di instradamento',
  'adm.groups.saved': 'Gruppo salvato.',
  'adm.groups.searchAria': 'Cerca gruppi',
  'adm.groups.searchPlaceholder': 'Cerca per nome',
  'adm.groups.selectActiveAgent': 'Seleziona agente attivo',
  'adm.groups.showing': 'Visualizzati {start}-{end} di {total}',
  'adm.groups.subtitle': 'I gruppi controllano l’instradamento e la visibilità dei ticket. Assegna gli agenti come membri e scegli un orario lavorativo e un contatto di escalation per ogni gruppo.',
  'adm.groups.title': 'Gruppi',
  'adm.groups.tryDifferent': 'Prova con un altro nome di gruppo.',
  'adm.groups.unassigned': 'Non assegnato',
  'adm.groups.useNew': 'Usa Nuovo gruppo per instradare i ticket a un insieme di agenti.',
  'adm.groups.zero': '0 gruppi',
  'adm.inactive': 'Inattivo',
  'adm.jira.accepted': 'Connessione accettata',
  'adm.jira.accountEmail': 'Email dell’account Jira',
  'adm.jira.accountEmailLabel': 'Email dell’account',
  'adm.jira.activeConn': 'Connessione attiva',
  'adm.jira.addConnection': 'Aggiungi connessione',
  'adm.jira.addTitle': 'Aggiungi connessione Jira',
  'adm.jira.added': 'Connessione Jira aggiunta',
  'adm.jira.apiToken': 'Token API',
  'adm.jira.clearSecret': 'Cancella il segreto webhook salvato',
  'adm.jira.confirmDesc': 'Questo rimuove la connessione salvata e i relativi collegamenti ai ticket. Le issue Jira non vengono eliminate.',
  'adm.jira.confirmLabel': 'Elimina connessione',
  'adm.jira.confirmTitle': 'Eliminare {name}?',
  'adm.jira.connName': 'Nome della connessione',
  'adm.jira.connNamePh': 'Jira Sviluppo',
  'adm.jira.connectedAs': 'Connesso come {name}',
  'adm.jira.connectionDesk': 'Gestione connessioni',
  'adm.jira.default': 'Predefinita',
  'adm.jira.defaultConn': 'Connessione predefinita',
  'adm.jira.defaultIssueType': 'Tipo di issue predefinito',
  'adm.jira.defaultProjectKey': 'Chiave progetto predefinita',
  'adm.jira.defaults': 'Predefiniti',
  'adm.jira.description': 'Collega i siti Jira dell’account in modo che gli agenti possano collegare le issue e mantenere allineato lo stato dei ticket.',
  'adm.jira.editTitle': 'Modifica connessione Jira',
  'adm.jira.footer': 'Crea il webhook Jira con l’endpoint mostrato sopra, sottoscrivi gli eventi di aggiornamento delle issue e usa lo stesso segreto webhook configurato qui.',
  'adm.jira.heading': 'Mantieni supporto e sviluppo sempre allineati',
  'adm.jira.intro': 'Le credenziali sono archiviate in forma cifrata sul server e non vengono mai mostrate in questa schermata. Configura un segreto webhook quando Jira deve inviare le modifiche di stato a SuzukiDesk.',
  'adm.jira.no': 'No',
  'adm.jira.noConns': 'Ancora nessuna connessione Jira',
  'adm.jira.noConnsDesc': 'Aggiungi una connessione per rendere disponibili le azioni Jira dal dettaglio del ticket.',
  'adm.jira.noProject': 'Nessun progetto',
  'adm.jira.pasteToken': 'Incolla il token',
  'adm.jira.requestFailed': 'Richiesta Jira non riuscita. Riprova.',
  'adm.jira.savedToast': 'Connessione Jira salvata',
  'adm.jira.secretConfigured': 'Segreto configurato: {value}',
  'adm.jira.secretHint': 'Usa lo stesso segreto quando crei il webhook Jira.',
  'adm.jira.secretOptional': 'Facoltativo, almeno 16 caratteri',
  'adm.jira.siteUrl': 'URL del sito Jira',
  'adm.jira.siteUrlHint': 'Non includere le credenziali nell’URL.',
  'adm.jira.syncFromJira': 'Stato Jira verso il ticket',
  'adm.jira.syncSnapshot': 'Snapshot dell’issue collegata',
  'adm.jira.syncToJira': 'Stato del ticket verso Jira',
  'adm.jira.testConnection': 'Testa connessione',
  'adm.jira.testFailed': 'Test di connessione non riuscito',
  'adm.jira.title': 'Integrazione Jira',
  'adm.jira.tokenHintEdit': 'Lascia vuoto per mantenere il token attuale.',
  'adm.jira.tokenHintNew': 'Archiviato in forma cifrata; non verrà mostrato di nuovo.',
  'adm.jira.tokenMissing': 'Token API mancante',
  'adm.jira.tokenStored': 'Token API salvato',
  'adm.jira.unchanged': '(invariato se vuoto)',
  'adm.jira.verified': 'Connessione Jira verificata',
  'adm.jira.webhookEndpoint': 'Endpoint webhook Jira',
  'adm.jira.webhookSecret': 'Segreto webhook',
  'adm.jira.whatSyncs': 'Cosa viene sincronizzato',
  'adm.jira.yes': 'Sì',
  'adm.nameRequired': 'Nome *',
  'adm.nextPage': 'Pagina successiva',
  'adm.notif.aud.all': 'Condiviso',
  'adm.notif.aud.customer': 'Cliente',
  'adm.notif.aud.internal': 'Interno',
  'adm.notif.audEmail': 'Email {audience}',
  'adm.notif.body': 'Corpo',
  'adm.notif.description': 'Personalizza ogni pubblico di notifica senza indirizzare i clienti verso l’area di lavoro interna.',
  'adm.notif.discardDesc': 'Le modifiche non salvate a questo modello di notifica andranno perse se cambi modello.',
  'adm.notif.discardLabel': 'Annulla modifiche',
  'adm.notif.discardTitle': 'Annullare le modifiche non salvate?',
  'adm.notif.discarded': 'Modifiche non salvate annullate.',
  'adm.notif.event.automation_notification': 'Notifica di automazione',
  'adm.notif.event.group_member_added': 'Aggiunto a un gruppo',
  'adm.notif.event.mention': 'Menzione',
  'adm.notif.event.pending_input': 'In attesa di input',
  'adm.notif.event.sla_breach': 'Violazione SLA',
  'adm.notif.event.sla_escalation': 'Escalation SLA',
  'adm.notif.event.sla_warning': 'Avviso SLA',
  'adm.notif.event.ticket_assigned': 'Ticket assegnato',
  'adm.notif.event.ticket_created': 'Ticket creato',
  'adm.notif.event.ticket_first_response': 'Prima risposta',
  'adm.notif.event.ticket_group_assigned': 'Ticket assegnato a un gruppo',
  'adm.notif.event.ticket_note': 'Nota privata',
  'adm.notif.event.ticket_public_note': 'Nota pubblica',
  'adm.notif.event.ticket_reply': 'Risposta al ticket',
  'adm.notif.event.ticket_resolved': 'Ticket risolto',
  'adm.notif.events': 'Eventi',
  'adm.notif.eventsHelp': 'Scegli un evento e il pubblico destinatario.',
  'adm.notif.insertVar': 'Inserisci {variable}',
  'adm.notif.linkNoteAgent': 'La variabile link adattata al pubblico {variable} apre l’area di lavoro degli agenti per questa email.',
  'adm.notif.linkNoteCustomer': 'La variabile link adattata al pubblico {variable} apre il portale clienti per questa email.',
  'adm.notif.off': 'off',
  'adm.notif.preview': 'Anteprima',
  'adm.notif.previewNotice': 'Anteprima generata con dati di esempio.',
  'adm.notif.rendering': 'Generazione…',
  'adm.notif.route.all': 'Usa il link al ticket adattato al destinatario per il pubblico di consegna.',
  'adm.notif.route.customer': 'L’azione principale apre il ticket nel portale clienti.',
  'adm.notif.route.internal': 'L’azione principale apre il ticket nell’area di lavoro degli agenti.',
  'adm.notif.sampleOnlyAgent': 'Solo dati di esempio: l’azione principale punta al percorso dell’area di lavoro degli agenti.',
  'adm.notif.sampleOnlyCustomer': 'Solo dati di esempio: l’azione principale punta al percorso del portale clienti.',
  'adm.notif.saveChanges': 'Salva modifiche',
  'adm.notif.saved': 'Modello salvato.',
  'adm.notif.savedBtn': 'Salvato',
  'adm.notif.selectEvent': 'Seleziona un evento per modificarne il modello',
  'adm.notif.selectEventDesc': 'Scegli un evento di notifica a sinistra per modificarne oggetto e corpo.',
  'adm.notif.sendTest': 'Invia email di prova',
  'adm.notif.sending': 'Invio…',
  'adm.notif.subject': 'Oggetto',
  'adm.notif.testQueued': 'Email di prova in coda per {email}.',
  'adm.notif.title': 'Modelli di notifica',
  'adm.notif.urlVarTitle': 'Variabile link adattata al pubblico',
  'adm.notif.useTemplate': 'Usa questo modello per questo pubblico',
  'adm.notif.useTemplateHelp': 'Se disattivato, viene usata la notifica di riserva predefinita.',
  'adm.notif.variables': 'Variabili',
  'adm.notif.variablesHelp': 'Clicca per aggiungere al corpo del messaggio',
  'adm.pagination': 'Paginazione',
  'adm.perm.cap.admin.label': 'Accedere alla console di amministrazione',
  'adm.perm.cap.assign.label': 'Assegnare un ticket',
  'adm.perm.cap.close.label': 'Chiudere un ticket',
  'adm.perm.cap.conversation_delete.label': 'Eliminare una risposta o una nota pubblicata',
  'adm.perm.cap.conversation_edit.label': 'Modificare una risposta o una nota pubblicata',
  'adm.perm.cap.create.label': 'Creare un ticket',
  'adm.perm.cap.delete.label': 'Eliminare un ticket',
  'adm.perm.cap.edit.label': 'Modificare le proprietà del ticket',
  'adm.perm.cap.export.label': 'Esportare i ticket',
  'adm.perm.cap.field_admin.label': 'Campi del ticket',
  'adm.perm.cap.form_admin.label': 'Moduli del ticket',
  'adm.perm.cap.forward.label': 'Inoltrare un ticket',
  'adm.perm.cap.jira_link.label': 'Collegare e gestire le issue Jira',
  'adm.perm.cap.kb.label': 'Accedere alla knowledge base',
  'adm.perm.cap.manage_agents.label': 'Agenti',
  'adm.perm.cap.manage_api_keys.label': 'Chiavi API',
  'adm.perm.cap.manage_automations.label': 'Automazioni',
  'adm.perm.cap.manage_canned_responses.label': 'Risposte predefinite',
  'adm.perm.cap.manage_email_config.label': 'Email',
  'adm.perm.cap.manage_groups.label': 'Gruppi',
  'adm.perm.cap.manage_jira.label': 'Integrazione Jira',
  'adm.perm.cap.manage_kb.label': 'Knowledge base',
  'adm.perm.cap.manage_notification_templates.label': 'Modelli di notifica',
  'adm.perm.cap.manage_roles.label': 'Ruoli',
  'adm.perm.cap.manage_tags.label': 'Tag',
  'adm.perm.cap.note.label': 'Aggiungere o modificare note private',
  'adm.perm.cap.reassign.label': 'Riassegnare un ticket già assegnato a qualcun altro',
  'adm.perm.cap.reopen.label': 'Riaprire un ticket risolto o chiuso',
  'adm.perm.cap.reply.label': 'Rispondere pubblicamente al cliente',
  'adm.perm.cap.report_access.label': 'Visualizzare report e dashboard',
  'adm.perm.cap.reports.label': 'Accedere al modulo report',
  'adm.perm.cap.resolve.label': 'Risolvere un ticket',
  'adm.perm.cap.settings_admin.label': 'Aprire la sezione Impostazioni (necessario per vedere la voce di menu Impostazioni e la relativa pagina indice; l’accesso a ciascuna pagina sottostante resta controllato separatamente)',
  'adm.perm.cap.sla_admin.label': 'Policy SLA e orari lavorativi',
  'adm.perm.cap.sla_edit.desc': 'Distinto dal permesso Impostazioni > Policy SLA riportato sotto: riguarda solo la modifica delle scadenze di un singolo ticket.',
  'adm.perm.cap.sla_edit.label': 'Modificare manualmente le scadenze SLA di un ticket',
  'adm.perm.cap.tag.label': 'Gestire i tag dei ticket',
  'adm.perm.cap.thread_start.label': 'Avviare una discussione privata su una voce della conversazione',
  'adm.perm.cap.tickets.label': 'Accedere all’area di lavoro dei ticket',
  'adm.perm.cap.view.label': 'Visualizzare i ticket nel proprio ambito',
  'adm.perm.cat.administration.desc': 'Accesso alla console di amministrazione e alle relative schermate di configurazione.',
  'adm.perm.cat.administration.label': 'Amministrazione',
  'adm.perm.cat.knowledge.desc': 'Lettura e uso dei contenuti della knowledge base durante la gestione di un ticket.',
  'adm.perm.cat.knowledge.label': 'Knowledge base',
  'adm.perm.cat.reporting.desc': 'Report operativi e dashboard.',
  'adm.perm.cat.reporting.label': 'Report',
  'adm.perm.cat.settings-pages.desc': 'Concedi l’accesso a ciascuna schermata delle Impostazioni singolarmente. Nulla è visibile finché non viene selezionato qui.',
  'adm.perm.cat.settings-pages.label': 'Pagine delle impostazioni',
  'adm.perm.cat.tickets.desc': 'Cosa può fare un agente nell’area di lavoro dei ticket.',
  'adm.perm.cat.tickets.label': 'Ticket',
  'adm.previousPage': 'Pagina precedente',
  'adm.refresh': 'Aggiorna',
  'adm.roleType.administrator': 'Amministratore',
  'adm.roleType.agent': 'Agente',
  'adm.roleType.collaborator': 'Collaboratore',
  'adm.roleType.customer': 'Cliente',
  'adm.roleType.super_admin': 'Super amministratore',
  'adm.roleType.supervisor': 'Supervisore',
  'adm.roles.activeHelp': 'Attivo - i ruoli inattivi non possono essere assegnati agli agenti',
  'adm.roles.agentCan': 'L’agente può',
  'adm.roles.agentType': 'Tipo di agente',
  'adm.roles.agentsAssignedNote': 'Gli agenti vengono associati a questo ruolo dalla schermata Agenti.',
  'adm.roles.agentsCount': '{count} agenti',
  'adm.roles.agentsLabel': 'Agenti',
  'adm.roles.agentsManage': '{count} agenti - Gestisci',
  'adm.roles.builtIn': '(Integrato)',
  'adm.roles.builtInNote': 'Questo è un ruolo integrato. Può essere rinominato e disattivato, ma non eliminato.',
  'adm.roles.builtInTitle': 'Ruolo integrato: modificabile e disattivabile, ma non eliminabile',
  'adm.roles.categoriesAria': 'Categorie di permessi',
  'adm.roles.confirmDesc': 'Gli agenti assegnati a questo ruolo dovranno avere un altro ruolo prima che questo possa essere rimosso.',
  'adm.roles.confirmLabel': 'Elimina ruolo',
  'adm.roles.createFirst': 'Crea il tuo primo ruolo',
  'adm.roles.createFirstDesc': 'Usa Nuovo ruolo per definire le funzionalità che gli agenti dovranno avere.',
  'adm.roles.editRole': 'Modifica ruolo',
  'adm.roles.granted': '{count} concessi',
  'adm.roles.heading': 'Ruoli degli agenti',
  'adm.roles.inactive': 'Inattivo',
  'adm.roles.newRole': 'Nuovo ruolo',
  'adm.roles.noAgent': 'Nessun agente',
  'adm.roles.notEnforced': '(non ancora applicato)',
  'adm.roles.notEnforcedTitle': 'Memorizzato nel ruolo ma non ancora applicato in nessun punto durante l’esecuzione',
  'adm.roles.permissions': 'Permessi',
  'adm.roles.saved': 'Ruolo salvato.',
  'adm.roles.scopeBody': 'Le funzionalità si combinano con l’ambito a livello di riga (tutti / gruppo / assegnati / propri), quindi un agente agisce sempre e solo sui ticket che può già vedere.',
  'adm.roles.scopeTitle': 'L’ambito continua ad applicarsi',
  'adm.roles.scrollTo': 'Vai a',
  'adm.roles.status': 'Stato',
  'adm.roles.subtitle': 'Concedi e limita livelli granulari di accesso e privilegi per gli agenti.',
  'adm.roles.title': 'Ruoli',
  'adm.roles.typeLocked': 'Il tipo di agente non può essere modificato dopo aver salvato un ruolo.',
  'adm.roles.understandingBody1': 'I ruoli stabiliscono cosa può fare un agente. Crea un ruolo, seleziona le funzionalità da concedere, quindi assegnalo agli agenti dalla schermata Agenti.',
  'adm.roles.understandingBody2': 'I ruoli integrati possono essere rinominati e disattivati ma mai eliminati. Nemmeno un ruolo con agenti ancora assegnati può essere eliminato: sposta prima quegli agenti.',
  'adm.roles.understandingTitle': 'Come funzionano i ruoli',
  'adm.saveChanges': 'Salva modifiche',
  'adm.settings.add': 'Aggiungi: {name}',
  'adm.settings.back': 'Torna alle impostazioni',
  'adm.settings.cannedDesc': 'Risposte dell’account a tua disposizione mentre lavori su un ticket.',
  'adm.settings.cannedEmpty': 'Ancora nessuna risposta predefinita',
  'adm.settings.cannedEmptyDesc': 'Chiedi a un amministratore di aggiungere risposte condivise che il tuo team possa riutilizzare nei ticket.',
  'adm.settings.cannedTitle': 'Risposte predefinite',
  'adm.settings.col.autoAssign': 'Assegnazione automatica',
  'adm.settings.col.color': 'Colore',
  'adm.settings.col.content': 'Contenuto',
  'adm.settings.col.createdAt': 'Creato il',
  'adm.settings.col.description': 'Descrizione',
  'adm.settings.col.email': 'Email',
  'adm.settings.col.expiresAt': 'Scade il',
  'adm.settings.col.fieldType': 'Tipo di campo',
  'adm.settings.col.firstName': 'Nome',
  'adm.settings.col.folderId': 'ID cartella',
  'adm.settings.col.hitCount': 'Esecuzioni',
  'adm.settings.col.holidays': 'Festività',
  'adm.settings.col.host': 'Host',
  'adm.settings.col.hours': 'Orari',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Attivo',
  'adm.settings.col.isBuiltIn': 'Integrato',
  'adm.settings.col.isDefault': 'Predefinito',
  'adm.settings.col.isRequired': 'Obbligatorio',
  'adm.settings.col.isShared': 'Condiviso',
  'adm.settings.col.isSystem': 'Di sistema',
  'adm.settings.col.key': 'Chiave',
  'adm.settings.col.label': 'Etichetta',
  'adm.settings.col.language': 'Lingua',
  'adm.settings.col.lastName': 'Cognome',
  'adm.settings.col.lastUsedAt': 'Ultimo utilizzo',
  'adm.settings.col.name': 'Nome',
  'adm.settings.col.options': 'Opzioni',
  'adm.settings.col.phone': 'Telefono',
  'adm.settings.col.port': 'Porta',
  'adm.settings.col.position': 'Posizione',
  'adm.settings.col.prefix': 'Prefisso',
  'adm.settings.col.priority': 'Priorità',
  'adm.settings.col.required': 'Obbligatorio',
  'adm.settings.col.role': 'Ruolo',
  'adm.settings.col.roleId': 'ID ruolo',
  'adm.settings.col.scopes': 'Ambiti',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Stato',
  'adm.settings.col.stopProcessing': 'Interrompi elaborazione',
  'adm.settings.col.timezone': 'Fuso orario',
  'adm.settings.col.title': 'Titolo',
  'adm.settings.col.trigger': 'Trigger',
  'adm.settings.col.type': 'Tipo',
  'adm.settings.col.updatedAt': 'Aggiornato il',
  'adm.settings.col.usageCount': 'Utilizzi',
  'adm.settings.col.username': 'Nome utente',
  'adm.settings.confirmDesc': 'Questa operazione non può essere annullata.',
  'adm.settings.confirmTitle': 'Eliminare {name}?',
  'adm.settings.count': '{count} {title}',
  'adm.settings.create': 'Crea',
  'adm.settings.empty': 'Ancora nessun elemento in {title}',
  'adm.settings.emptyAdd': 'Usa il modulo qui sopra per aggiungere il primo elemento: {name}.',
  'adm.settings.emptyOther': 'Le voci appariranno qui una volta configurate.',
  'adm.settings.homeDesc': 'Configura utenti, flussi di lavoro dei ticket, livelli di servizio e integrazioni.',
  'adm.settings.manage': 'Gestisci: {title}.',
  'adm.settings.noPages': 'Nessuna pagina di impostazioni disponibile',
  'adm.settings.noPagesDesc': 'Chiedi a un super amministratore di concederti l’accesso alle pagine di impostazioni di cui hai bisogno.',
  'adm.settings.notFound': 'Pagina di impostazioni non trovata',
  'adm.settings.notFoundDesc': 'Scegli un’area delle impostazioni per continuare.',
  'adm.settings.res.agents.field.email': 'Email',
  'adm.settings.res.agents.field.firstName': 'Nome',
  'adm.settings.res.agents.field.lastName': 'Cognome',
  'adm.settings.res.agents.field.password': 'Password temporanea',
  'adm.settings.res.agents.field.roleId': 'ID ruolo',
  'adm.settings.res.agents.one': 'agente',
  'adm.settings.res.agents.title': 'Agenti',
  'adm.settings.res.api-keys.field.name': 'Nome della chiave',
  'adm.settings.res.api-keys.one': 'chiave API',
  'adm.settings.res.api-keys.title': 'Chiavi API',
  'adm.settings.res.automations.field.description': 'Descrizione',
  'adm.settings.res.automations.field.name': 'Nome',
  'adm.settings.res.automations.one': 'automazione',
  'adm.settings.res.automations.title': 'Automazioni',
  'adm.settings.res.business-hours.field.name': 'Nome',
  'adm.settings.res.business-hours.field.timezone': 'Fuso orario',
  'adm.settings.res.business-hours.one': 'orario lavorativo',
  'adm.settings.res.business-hours.title': 'Orari lavorativi',
  'adm.settings.res.canned-responses.field.content': 'Contenuto della risposta',
  'adm.settings.res.canned-responses.field.title': 'Titolo',
  'adm.settings.res.canned-responses.one': 'risposta predefinita',
  'adm.settings.res.canned-responses.title': 'Risposte predefinite',
  'adm.settings.res.email.field.host': 'Host SMTP',
  'adm.settings.res.email.field.name': 'Nome',
  'adm.settings.res.email.field.port': 'Porta SMTP',
  'adm.settings.res.email.field.username': 'Nome utente',
  'adm.settings.res.email.one': 'configurazione email',
  'adm.settings.res.email.title': 'Configurazione email',
  'adm.settings.res.fields.one': 'campo del ticket',
  'adm.settings.res.fields.title': 'Campi del ticket',
  'adm.settings.res.forms.field.label': 'Etichetta visualizzata',
  'adm.settings.res.forms.field.name': 'Nome del campo',
  'adm.settings.res.forms.field.type': 'Tipo di campo',
  'adm.settings.res.forms.one': 'modulo o campo personalizzato',
  'adm.settings.res.forms.title': 'Moduli e campi personalizzati',
  'adm.settings.res.groups.field.description': 'Descrizione',
  'adm.settings.res.groups.field.name': 'Nome',
  'adm.settings.res.groups.one': 'gruppo',
  'adm.settings.res.groups.title': 'Gruppi',
  'adm.settings.res.jira.one': 'integrazione Jira',
  'adm.settings.res.jira.title': 'Integrazione Jira',
  'adm.settings.res.kb.field.content': 'Contenuto dell’articolo',
  'adm.settings.res.kb.field.folderId': 'ID cartella',
  'adm.settings.res.kb.field.title': 'Titolo dell’articolo',
  'adm.settings.res.kb.one': 'articolo della knowledge base',
  'adm.settings.res.kb.title': 'Amministrazione della knowledge base',
  'adm.settings.res.notification-templates.one': 'modello di notifica',
  'adm.settings.res.notification-templates.title': 'Modelli di notifica',
  'adm.settings.res.roles.field.description': 'Descrizione',
  'adm.settings.res.roles.field.name': 'Nome',
  'adm.settings.res.roles.field.type': 'Tipo di ruolo',
  'adm.settings.res.roles.one': 'ruolo',
  'adm.settings.res.roles.title': 'Ruoli',
  'adm.settings.res.sla.field.description': 'Descrizione',
  'adm.settings.res.sla.field.name': 'Nome',
  'adm.settings.res.sla.one': 'policy SLA',
  'adm.settings.res.sla.title': 'Policy SLA',
  'adm.settings.res.tags.field.name': 'Nome',
  'adm.settings.res.tags.one': 'tag',
  'adm.settings.res.tags.title': 'Tag',
  'adm.settings.title': 'Impostazioni',
  'adm.status': 'Stato',

  'sla.edit': 'Modifica',
  'sla.active': 'Attivo',
  'sla.inactive': 'Inattivo',
  'sla.default': 'Predefinita',
  'sla.yes': 'Sì',
  'sla.no': 'No',
  'sla.description': 'Descrizione',
  'sla.status': 'Stato',
  'sla.notConfigured': 'Non configurato',
  'sla.minutesValue': '{value} minuti',
  'sla.invalidServerValue': 'Valore del server non valido',
  'sla.statusSemantics.title': 'Semantica degli stati del ticket',
  'sla.statusSemantics.description': 'Ogni stato attivo ha un contratto SLA esplicito. Uno stato che mette in pausa lo SLA e uno stato che lo interrompe si escludono a vicenda.',
  'sla.statusSemantics.conflict': 'Uno stato non può mettere in pausa e interrompere lo SLA contemporaneamente.',
  'sla.statusSemantics.emptyTitle': 'Nessuna definizione di stato',
  'sla.statusSemantics.emptyDescription': 'Le definizioni degli stati compariranno qui una volta configurate per questo account.',
  'sla.statusSemantics.colPauses': 'Mette in pausa lo SLA',
  'sla.statusSemantics.colStops': 'Interrompe lo SLA',
  'sla.statusSemantics.pausesAria': '{label} mette in pausa lo SLA',
  'sla.statusSemantics.stopsAria': '{label} interrompe lo SLA',
  'sla.preview.title': 'Anteprima ticket di sola lettura',
  'sla.preview.description': 'Esegue lo stesso valutatore a livello di account usato dai cicli SLA in produzione. Questa anteprima non scrive mai una policy o un ticket.',
  'sla.preview.priority': 'Priorità',
  'sla.preview.group': 'Gruppo',
  'sla.preview.anyGroup': 'Qualsiasi gruppo',
  'sla.preview.company': 'Azienda',
  'sla.preview.anyCompany': 'Qualsiasi azienda',
  'sla.preview.source': 'Origine',
  'sla.preview.anySource': 'Qualsiasi origine',
  'sla.preview.ticketType': 'Tipo di ticket',
  'sla.preview.anyTicketType': 'Qualsiasi tipo di ticket',
  'sla.preview.representativeStart': 'Inizio rappresentativo',
  'sla.preview.calculating': 'Calcolo in corso…',
  'sla.preview.run': 'Esegui anteprima',
  'sla.preview.configAttention': 'La configurazione richiede attenzione',
  'sla.preview.selectedPolicy': 'Policy selezionata',
  'sla.preview.noPolicy': 'Nessuna policy',
  'sla.preview.evaluationOrder': 'Ordine di valutazione',
  'sla.preview.firstMatching': 'Prima policy corrispondente',
  'sla.preview.calculationMode': 'Modalità di calcolo',
  'sla.preview.modeBusinessHours': 'Orari di lavoro',
  'sla.preview.modeBusinessHoursNamed': 'Orari di lavoro · {name}',
  'sla.preview.mode247': 'Tempo trascorso 24/7',
  'sla.preview.modeNone': 'Non calcolato',
  'sla.preview.thresholds': 'Soglie indipendenti',
  'sla.preview.colMetric': 'Metrica',
  'sla.preview.colTarget': 'Obiettivo',
  'sla.preview.colWarning': 'Avviso',
  'sla.preview.colDue': 'Scadenza / violazione',
  'sla.preview.colEscalation': 'Escalation',
  'sla.preview.colState': 'Stato',
  'sla.preview.metricFirstResponse': 'Prima risposta',
  'sla.preview.metricResolution': 'Risoluzione',
  'sla.preview.trace': 'Traccia di valutazione delle policy',
  'sla.preview.selected': 'Selezionata',
  'sla.preview.matchedAfterSelection': 'Corrispondente dopo la selezione',
  'sla.preview.skipped': 'Saltata',
  'sla.preview.showTrace': 'Mostra traccia di calcolo',
  'sla.state.not_configured': 'non configurato',
  'sla.state.running': 'in corso',
  'sla.state.paused': 'in pausa',
  'sla.state.warning': 'avviso',
  'sla.state.breached': 'violato',
  'sla.state.met': 'rispettato',
  'sla.state.escalated': 'escalato',
  'sla.state.pending': 'in attesa',
  'sla.state.stopped': 'interrotto',
  'sla.state.on_track': 'nei tempi',
  'sla.state.at_risk': 'a rischio',
  'sla.list.subtitle': 'Imposta gli obiettivi di prima risposta e di risoluzione per priorità. Le policy vengono valutate dall’alto verso il basso: vince la prima le cui condizioni corrispondono a un ticket.',
  'sla.list.newPolicy': 'Nuova policy',
  'sla.list.emptyTitle': 'Crea la tua prima policy SLA',
  'sla.list.emptyDescription': 'Usa Nuova policy per impostare gli obiettivi di prima risposta e di risoluzione per priorità.',
  'sla.list.moveUp': 'Sposta su',
  'sla.list.moveDown': 'Sposta giù',
  'sla.list.frShort': 'PR: {value}',
  'sla.list.resolveShort': 'Risoluzione: {value}',
  'sla.list.escalateShort': 'Escalation: +{value}',
  'sla.list.deactivate': 'Disattiva',
  'sla.list.activate': 'Attiva',
  'sla.list.setDefault': 'Imposta come predefinita',
  'sla.list.duplicate': 'Duplica',
  'sla.list.deleteTitle': 'Eliminare “{name}”?',
  'sla.list.deleteDescription': 'I ticket associati a questa policy useranno la successiva policy SLA disponibile.',
  'sla.list.deleteConfirm': 'Elimina policy',
  'sla.conditions.groups': '{count} gruppo/i',
  'sla.conditions.companies': '{count} azienda/e',
  'sla.conditions.sources': 'origini: {list}',
  'sla.conditions.ticketTypes': '{count} tipo/i di ticket',
  'sla.conditions.anyOf': 'almeno una',
  'sla.conditions.allOf': 'tutte',
  'sla.conditions.summary': 'Condizioni ({mode}): {parts}',
  'sla.edit.newTitle': 'Nuova policy SLA',
  'sla.edit.editTitle': 'Modifica policy SLA',
  'sla.edit.saved': 'Policy SLA salvata.',
  'sla.edit.name': 'Nome',
  'sla.edit.appliesToPriority': 'Si applica alla priorità',
  'sla.edit.evaluationOrder': 'Ordine di valutazione',
  'sla.edit.evaluationOrderHint': 'Le posizioni più basse vengono valutate per prime per questo account.',
  'sla.edit.defaultPolicy': 'Policy predefinita',
  'sla.edit.useAsDefault': 'Usa come predefinita quando nessun’altra policy corrisponde',
  'sla.edit.targets': 'Obiettivi SLA',
  'sla.edit.firstResponse': 'Prima risposta',
  'sla.edit.resolution': 'Risoluzione',
  'sla.edit.autoAt75': 'Automatico al 75%',
  'sla.edit.enabledAfter': 'Attivo dopo {value}',
  'sla.edit.clearEscalation': 'Cancella esplicitamente l’obiettivo di escalation',
  'sla.edit.clearEscalationHint': 'Invia null; se lasci la casella deselezionata il campo viene omesso e il valore salvato viene mantenuto.',
  'sla.edit.firstResponseMinutes': 'Prima risposta (minuti)',
  'sla.edit.resolutionMinutes': 'Risoluzione (minuti)',
  'sla.edit.escalateAfter': 'Escalation dopo (minuti oltre la scadenza di risoluzione)',
  'sla.edit.notSet': 'Non impostato',
  'sla.edit.remindersNote': 'I promemoria scattano automaticamente al 75% delle finestre di prima risposta e di risoluzione. L’escalation notifica l’agente di escalation del gruppo del ticket (impostato sul gruppo) quando l’obiettivo di risoluzione è stato superato del numero di minuti configurato.',
  'sla.edit.conditions': 'Condizioni',
  'sla.edit.conditionsHint': 'Lascia un gruppo deselezionato per far corrispondere tutti i valori',
  'sla.edit.matchMode': 'Modalità di corrispondenza:',
  'sla.edit.matchAll': 'Corrisponde a TUTTE le condizioni',
  'sla.edit.matchAny': 'Corrisponde a QUALSIASI condizione',
  'sla.edit.groups': 'Gruppi',
  'sla.edit.companies': 'Aziende',
  'sla.edit.sources': 'Origini',
  'sla.edit.ticketTypes': 'Tipi di ticket',
  'sla.bh.subtitle': 'Definisci il calendario settimanale e quello delle festività che le policy SLA usano per calcolare le scadenze.',
  'sla.bh.newCalendar': 'Nuovo calendario',
  'sla.bh.emptyTitle': 'Crea il tuo primo calendario degli orari di lavoro',
  'sla.bh.emptyDescription': 'Usa Nuovo calendario per definire l’orario settimanale su cui le policy SLA calcolano i tempi.',
  'sla.bh.accountDefault': 'Predefinito dell’account',
  'sla.bh.closedEveryDay': 'Chiuso tutti i giorni',
  'sla.bh.openEveryDay': 'Aperto tutti i giorni',
  'sla.bh.openDaysOne': 'Aperto 1 giorno a settimana',
  'sla.bh.openDaysMany': 'Aperto {count} giorni a settimana',
  'sla.bh.holidayOne': '1 festività',
  'sla.bh.holidayMany': '{count} festività',
  'sla.bh.deleteTitle': 'Eliminare “{name}”?',
  'sla.bh.deleteDescription': 'Le policy SLA e i gruppi che usano questo orario torneranno al predefinito dell’account.',
  'sla.bh.deleteConfirm': 'Elimina orario',
  'sla.bh.newTitle': 'Nuovo calendario degli orari di lavoro',
  'sla.bh.editTitle': 'Modifica orari di lavoro',
  'sla.bh.saved': 'Orari di lavoro salvati.',
  'sla.bh.timezone': 'Fuso orario',
  'sla.bh.defaultCalendar': 'Calendario predefinito',
  'sla.bh.useAsDefault': 'Usa per le policy SLA e i gruppi che non specificano un proprio calendario',
  'sla.bh.weeklySchedule': 'Orario settimanale',
  'sla.bh.colDay': 'Giorno',
  'sla.bh.colOpen': 'Aperto',
  'sla.bh.colStart': 'Inizio',
  'sla.bh.colEnd': 'Fine',
  'sla.bh.dayOpenAria': '{day} aperto',
  'sla.bh.dayStartAria': '{day} ora di inizio',
  'sla.bh.dayEndAria': '{day} ora di fine',
  'sla.bh.holidayCalendar': 'Calendario delle festività',
  'sla.bh.saveFirst': 'Salva prima questo calendario, poi aggiungi le festività.',
  'sla.bh.holidayName': 'Nome della festività',
  'sla.bh.date': 'Data',
  'sla.bh.addHoliday': 'Aggiungi festività',
  'sla.bh.noHolidays': 'Nessuna festività',
  'sla.bh.noHolidaysHint': 'Aggiungi sopra una festività con data per escluderla dai calcoli SLA.',
  'sla.bh.remove': 'Rimuovi',
  'sla.day.monday': 'Lunedì',
  'sla.day.tuesday': 'Martedì',
  'sla.day.wednesday': 'Mercoledì',
  'sla.day.thursday': 'Giovedì',
  'sla.day.friday': 'Venerdì',
  'sla.day.saturday': 'Sabato',
  'sla.day.sunday': 'Domenica',

  'set.ftype.single_line_text': 'Testo a riga singola',
  'set.ftype.multi_line_text': 'Testo su più righe',
  'set.ftype.dropdown': 'Menu a tendina',
  'set.ftype.checkbox': 'Casella di controllo',
  'set.ftype.radio': 'Pulsante di opzione',
  'set.ftype.multiselect': 'Selezione multipla',
  'set.ftype.lookup': 'Relazione di ricerca',
  'set.ftype.dependent': 'Campo dipendente',
  'set.ftype.date': 'Data',
  'set.ftype.number': 'Numero',
  'set.ftype.decimal': 'Decimale',
  'set.ftype.desc.lookup': 'Seleziona un record da una fonte di sistema.',
  'set.ftype.desc.single_line_text': 'Valore di testo breve.',
  'set.ftype.desc.multi_line_text': 'Valore di testo esteso.',
  'set.ftype.desc.checkbox': 'Valore vero o falso.',
  'set.ftype.desc.dropdown': "Seleziona un'opzione normalizzata.",
  'set.ftype.desc.dependent': 'Le opzioni dipendono da un campo padre.',
  'set.ftype.desc.date': 'Valore di data del calendario.',
  'set.ftype.desc.number': 'Valore numerico intero.',
  'set.ftype.desc.decimal': 'Valore numerico decimale.',
  'set.src.STATIC': 'Opzioni statiche',
  'set.src.AGENTS': 'Agenti',
  'set.src.USERS': 'Utenti / Clienti',
  'set.src.GROUPS': 'Gruppi',
  'set.src.ROLE': 'Ruoli',
  'set.src.COUNTRIES': 'Paesi',
  'set.src.CUSTOM': 'Elenco a discesa personalizzato',
  'set.settings': 'Impostazioni',
  'set.ticketFields': 'Campi ticket',
  'set.ticketForms': 'Moduli ticket',
  'set.requestFailed': 'Richiesta non riuscita. Riprova.',
  'set.refresh': 'Aggiorna',
  'set.saving': 'Salvataggio…',
  'set.saveChanges': 'Salva modifiche',
  'set.default': 'Predefinito',
  'set.published': 'Pubblicato',
  'set.draft': 'Bozza',
  'set.publish': 'Pubblica',
  'set.unpublish': 'Annulla pubblicazione',
  'set.deleteForm': 'Elimina modulo',
  'set.description': 'Descrizione',
  'set.relationshipSource': 'Origine della relazione',
  'set.dependsOn': 'Dipende da {field}',
  'set.deleteFormTitle': 'Eliminare “{name}”?',
  'set.deleteFormDescription': 'Questo modulo ticket e la sua configurazione verranno eliminati definitivamente.',
  'set.formIdRequired': 'È richiesto un ID del modulo.',
  'set.formNotFound': 'Modulo ticket non trovato.',
  'set.tf.removeOption': 'Rimuovi {label}',
  'set.tf.noOptions': 'Nessuna opzione definita.',
  'set.tf.addOptionPlaceholder': 'Aggiungi opzione...',
  'set.tf.add': 'Aggiungi',
  'set.tf.dependsOnField': 'Dipende dal campo',
  'set.tf.selectParent': '— Seleziona campo padre —',
  'set.tf.parentHelp': 'Il campo a tendina padre il cui valore selezionato determina le opzioni disponibili di questo campo.',
  'set.tf.optionMappings': 'Mappatura delle opzioni',
  'set.tf.savingParen': '(salvataggio...)',
  'set.tf.mappingsError': 'Impossibile caricare le mappature',
  'set.tf.archivedParen': ' (archiviato)',
  'set.tf.mappedCount': '{count} mappate',
  'set.tf.saveFirst': 'Salva prima il campo per configurare la mappatura delle opzioni.',
  'set.tf.newField': 'Nuovo {type}',
  'set.tf.pageDescription': "Gestisci le definizioni dei campi importati, la visibilità, le regole di obbligatorietà e l'ordine usato dai moduli ticket.",
  'set.tf.addField': 'Aggiungi campo',
  'set.tf.addFieldHelp': "Trascina un tipo nell'elenco dei campi oppure usa Aggiungi.",
  'set.tf.addType': 'Aggiungi {type}',
  'set.tf.registry': 'Registro dei campi',
  'set.tf.savingOrder': 'Salvataggio ordine…',
  'set.tf.searchAria': 'Cerca campi ticket',
  'set.tf.searchPlaceholder': 'Cerca per nome o chiave...',
  'set.tf.filterAria': 'Filtra per tipo di campo',
  'set.tf.allTypes': 'Tutti i tipi di campo',
  'set.tf.emptyFirstTitle': 'Aggiungi il tuo primo campo ticket',
  'set.tf.emptyFirstDesc': 'Trascina un tipo di campo dalla palette oppure usa Aggiungi per crearne uno.',
  'set.tf.emptyFilterTitle': 'Nessun campo corrisponde ai filtri',
  'set.tf.emptyFilterDesc': 'Prova un altro termine di ricerca o amplia il filtro per tipo di campo.',
  'set.tf.archived': 'Archiviato',
  'set.tf.dependent': 'Dipendente',
  'set.tf.customerVisible': 'Visibile al cliente',
  'set.tf.internal': 'Interno',
  'set.tf.configuration': 'Configurazione del campo',
  'set.tf.selectTitle': 'Seleziona un campo da configurare',
  'set.tf.selectDesc': 'Scegli un campo dal registro per modificarne etichette, regole e visibilità.',
  'set.tf.externalId': 'ID esterno: {value}',
  'set.tf.sourceRenderer': 'Origine: {source} · Rendering: {renderer}',
  'set.tf.optionSource': 'Origine opzioni: {value}',
  'set.tf.dependsOnKey': 'Dipende da: {value}',
  'set.tf.internalLabel': 'Etichetta interna',
  'set.tf.customerLabel': 'Etichetta per il cliente',
  'set.tf.relationshipHelp': 'Determina da dove vengono recuperati i valori di ricerca in fase di esecuzione.',
  'set.tf.validationVisibility': 'Validazione e visibilità',
  'set.tf.requiredAgents': 'Obbligatorio per gli agenti',
  'set.tf.requiredCustomers': 'Obbligatorio per i clienti',
  'set.tf.requiredClosure': 'Obbligatorio per la chiusura',
  'set.tf.displayedCustomers': 'Mostrato ai clienti',
  'set.tf.customersEdit': 'I clienti possono modificare',
  'set.tf.customersFilter': 'I clienti possono filtrare',
  'set.tf.active': 'Attivo',
  'set.tf.dropdownOptions': 'Opzioni del menu a tendina ({count})',
  'set.tf.archiveTitle': 'Archiviare “{name}”?',
  'set.tf.archiveDesc': 'Il campo diventerà inattivo e non disponibile per i nuovi ticket. I dati dei ticket esistenti vengono conservati.',
  'set.tf.archiveField': 'Archivia campo',
  'set.tf.alreadyArchived': 'Già archiviato',
  'set.tf.archivedNote': 'I campi archiviati restano disponibili per i valori storici.',
  'set.tfm.systemUser': 'Sistema',
  'set.tfm.untitled': 'Modulo senza titolo',
  'set.tfm.pageDescription': 'Crea moduli riutilizzabili e scegli quali campi importati possono usare agenti e clienti.',
  'set.tfm.newForm': 'Nuovo modulo',
  'set.tfm.creating': 'Creazione…',
  'set.tfm.allForms': 'Tutti i moduli',
  'set.tfm.configuredOne': '{count} modulo configurato',
  'set.tfm.configuredMany': '{count} moduli configurati',
  'set.tfm.filter': 'Filtra',
  'set.tfm.searchAria': 'Cerca moduli ticket',
  'set.tfm.searchPlaceholder': 'Cerca moduli…',
  'set.tfm.status': 'Stato',
  'set.tfm.allStatuses': 'Tutti gli stati',
  'set.tfm.emptyFilterTitle': 'Nessun modulo corrisponde ai filtri',
  'set.tfm.emptyFilterDesc': 'Prova un altro termine di ricerca o amplia il filtro di stato.',
  'set.tfm.emptyFirstTitle': 'Crea il tuo primo modulo ticket',
  'set.tfm.emptyFirstDesc': 'Crea un modulo per iniziare a configurare i campi importati.',
  'set.tfm.createFirst': 'Crea il tuo primo modulo',
  'set.tfm.colName': 'Nome',
  'set.tfm.colCreatedAt': 'Creato il',
  'set.tfm.colUpdatedBy': 'Ultimo aggiornamento di',
  'set.tfm.colUpdatedAt': 'Ultimo aggiornamento il',
  'set.tfm.colPortals': 'Portali associati',
  'set.tfm.colActions': 'Azioni',
  'set.tfm.notConfigured': 'Non configurato',
  'set.tfm.actionsFor': 'Azioni per {name}',
  'set.tfm.editForm': 'Modifica modulo',
  'set.tb.section.default.title': 'Campi predefiniti',
  'set.tb.section.default.desc': 'Campi principali del flusso di supporto importati dal sistema di origine.',
  'set.tb.section.custom.title': 'Campi personalizzati',
  'set.tb.section.custom.desc': 'Campi aggiuntivi configurati per il tuo processo di supporto.',
  'set.tb.section.nested.title': 'Campi nidificati',
  'set.tb.section.nested.desc': 'Campi dipendenti le cui opzioni seguono un campo padre.',
  'set.tb.discardTitle': 'Scartare le modifiche non salvate?',
  'set.tb.discardDesc': 'Le modifiche a questo modulo ticket non sono state salvate.',
  'set.tb.leave': 'Esci senza salvare',
  'set.tb.nameRequired': 'Il nome del modulo è obbligatorio.',
  'set.tb.saved': 'Modulo salvato.',
  'set.tb.nowPublished': 'Modulo pubblicato.',
  'set.tb.nowUnpublished': 'Pubblicazione del modulo annullata.',
  'set.tb.admin': 'Amministrazione',
  'set.tb.builder': 'Editor',
  'set.tb.titleAria': 'Titolo del modulo',
  'set.tb.defaultLocked': 'Predefinito / bloccato',
  'set.tb.previewPortal': 'Anteprima sul portale',
  'set.tb.configureTitle': 'Configura i campi inclusi in questo modulo.',
  'set.tb.configureDesc': 'Le modifiche vengono salvate nel database del supporto quando selezioni Salva modifiche. I campi obbligatori restano abilitati.',
  'set.tb.formDetails': 'Dettagli del modulo',
  'set.tb.formDetailsHelp': 'Usa una descrizione chiara in modo che gli amministratori sappiano quando usare questo modulo.',
  'set.tb.descPlaceholder': 'Descrivi quando usare questo modulo…',
  'set.tb.importedFields': 'Campi importati',
  'set.tb.importedHelp': "Trascina per riordinare i campi. Usa l'interruttore per includere o escludere un campo da questo modulo.",
  'set.tb.noneInSection': 'Nessun campo importato in questa sezione.',
  'set.tb.dragReorder': 'Trascina per riordinare',
  'set.tb.required': 'Obbligatorio',
  'set.tb.nested': 'Nidificato',
  'set.tb.enableField': 'Abilita {label}',
  'set.tb.enabled': 'Abilitato',
  'set.tb.disabled': 'Disabilitato',
  'set.tb.emptyTitle': 'Nessun campo da configurare',
  'set.tb.emptyDesc': 'Importa i campi ticket per iniziare a creare questo modulo.',
  'set.tb.deleting': 'Eliminazione…',
  'set.tp.loadError': "Impossibile caricare l'anteprima del modulo.",
  'set.tp.preview': 'Anteprima',
  'set.tp.customerPreview': 'Anteprima lato cliente',
  'set.tp.backToBuilder': "Torna all'editor",
  'set.tp.modeTitle': 'Modalità anteprima',
  'set.tp.modeDesc': "Questa è un'anteprima senza invio. Tutti i campi abilitati vengono mostrati nell'ordine salvato del modulo.",
  'set.tp.emptyTitle': 'Nessun campo abilitato',
  'set.tp.emptyDesc': "Abilita i campi nell'editor del modulo per vederli in questa anteprima.",

  'por.error.generic': 'Impossibile completare la richiesta.',
  'por.error.requestNotFound': 'Richiesta non trovata.',
  'por.error.formUnavailable': 'Il modulo di richiesta non è disponibile.',
  'por.error.articleNotFound': 'Articolo non trovato.',
  'por.error.selectRating': 'Seleziona una valutazione da 1 a 5.',
  'por.tab.all': 'Tutte',
  'por.list.title': 'Le mie richieste di assistenza',
  'por.list.description': 'Segui le tue richieste e rispondi al team di assistenza.',
  'por.list.newRequest': 'Nuova richiesta',
  'por.list.knowledgeBase': 'Knowledge base',
  'por.list.filterByStatus': 'Filtra le richieste per stato',
  'por.list.searchPlaceholder': 'Cerca per oggetto…',
  'por.list.count': '{count} richieste',
  'por.list.countOne': '{count} richiesta',
  'por.list.emptyFilteredTitle': 'Nessuna richiesta corrisponde a questa vista',
  'por.list.emptyTitle': 'Ancora nessuna richiesta',
  'por.list.emptyFilteredDescription': 'Prova la scheda Tutte o un altro termine di ricerca.',
  'por.list.emptyDescription': 'Invia una richiesta e il team di assistenza la prenderà in carico.',
  'por.list.submitFirst': 'Invia la tua prima richiesta',
  'por.col.request': 'Richiesta',
  'por.col.subject': 'Oggetto',
  'por.col.status': 'Stato',
  'por.col.priority': 'Priorità',
  'por.col.created': 'Creata',
  'por.detail.myRequests': 'Le mie richieste',
  'por.detail.reopen': 'Riapri questa richiesta',
  'por.detail.attachments': 'Allegati',
  'por.detail.download': 'Scarica',
  'por.detail.conversation': 'Conversazione',
  'por.detail.noReplies': 'Ancora nessuna risposta',
  'por.detail.noRepliesHint': 'Aggiungi una risposta qui sotto e il team di assistenza la prenderà in carico.',
  'por.detail.reply': 'Risposta',
  'por.detail.replyPlaceholder': 'Scrivi una risposta',
  'por.detail.sending': 'Invio in corso…',
  'por.detail.sendReply': 'Invia risposta',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': 'Rimuovi {name}',
  'por.submit.newRequest': 'Nuova richiesta',
  'por.submit.defaultTitle': 'Invia una richiesta di assistenza',
  'por.submit.intro': 'Compila i campi qui sotto e invia la tua richiesta.',
  'por.submit.subjectRequired': 'L’oggetto è obbligatorio',
  'por.submit.descriptionRequired': 'La descrizione è obbligatoria',
  'por.submit.attachments': 'Allegati',
  'por.submit.submitting': 'Invio in corso…',
  'por.submit.submit': 'Invia richiesta',
  'por.kb.portal': 'Portale',
  'por.kb.title': 'Knowledge base',
  'por.kb.description': 'Trova le risposte prima di inviare una richiesta.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Risultati di ricerca',
  'por.kb.searchPlaceholder': 'Cerca articoli',
  'por.kb.emptyTitle': 'Nessun articolo ancora pubblicato',
  'por.kb.emptyDescription': 'Invia una richiesta e il team di assistenza ti aiuterà direttamente.',
  'por.kb.noFolders': 'Nessuna cartella',
  'por.kb.articles': '{count} articoli',
  'por.kb.articlesOne': '{count} articolo',
  'por.kb.noMatch': 'Nessun articolo corrisponde a “{query}”',
  'por.kb.folderEmpty': 'Ancora nessun articolo in questa cartella',
  'por.kb.noMatchHint': 'Prova un termine di ricerca più breve oppure invia una richiesta.',
  'por.kb.folderEmptyHint': 'Sfoglia un’altra cartella oppure invia una richiesta.',
  'por.kb.submitRequest': 'Invia una richiesta',
  'por.kb.views': '{count} visualizzazioni',
  'por.kb.thanks': 'Grazie per il tuo feedback!',
  'por.kb.helpful': 'Ti è stato utile?',
  'por.kb.yes': 'Sì',
  'por.kb.no': 'No',
  'por.csat.thanksTitle': 'Grazie per il tuo feedback',
  'por.csat.thanksBody': 'La tua risposta è stata registrata.',
  'por.csat.title': 'Come siamo andati?',
  'por.csat.request': 'Richiesta #{number}: {subject}',
  'por.csat.rating': 'Valutazione',
  'por.csat.stars': '{count} stelle',
  'por.csat.comment': 'Commento',
  'por.csat.submit': 'Invia feedback',
  'agents.tempPassword.title': 'Password temporanea',
  'agents.tempPassword.help': 'Imposta una password temporanea per questo agente. Gli verrà chiesto di scegliere una nuova password al prossimo accesso. Almeno 12 caratteri, con una maiuscola, una minuscola, un numero e un simbolo.',
  'agents.tempPassword.button': 'Imposta password temporanea',
  'agents.tempPassword.saving': 'Impostazione…',
  'agents.tempPassword.error': 'Impossibile impostare la password temporanea.',
  'ui.showPassword': 'Mostra password',
  'ui.hidePassword': 'Nascondi password',
  'dashboard.awaitingResolutionConfirmation': 'In attesa di conferma della risoluzione',
  'dashboard.awaitingUserReply': 'In attesa di risposta dell’utente',
  'dashboard.changeRequests': 'Richieste di modifica',
  'agents.tempPassword.successEmailed': 'Password temporanea impostata e inviata via email all’agente.',
  'agents.tempPassword.successNotEmailed': 'Password temporanea impostata, ma non è stato possibile inviare l’email. Condividi la password con l’agente tramite un canale sicuro.',
} as const;

export default it;
